import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigFloat: any;
  Cursor: any;
  Date: any;
  Datetime: any;
  EmailAddressValue: any;
  GeoJSON: any;
  JSON: any;
  JwtToken: any;
  Time: any;
  UUID: any;
};

/** View to get all topics */
export type AllTopic = {
  __typename?: 'AllTopic';
  id?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `AllTopic` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AllTopicCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AllTopic` object types. All fields are combined with a logical ‘and.’ */
export type AllTopicFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AllTopicFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AllTopicFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AllTopicFilter>>;
};

/** A connection to a list of `AllTopic` values. */
export type AllTopicsConnection = {
  __typename?: 'AllTopicsConnection';
  /** A list of edges which contains the `AllTopic` and cursor to aid in pagination. */
  edges: Array<AllTopicsEdge>;
  /** A list of `AllTopic` objects. */
  nodes: Array<Maybe<AllTopic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllTopic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllTopic` edge in the connection. */
export type AllTopicsEdge = {
  __typename?: 'AllTopicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllTopic` at the end of the edge. */
  node?: Maybe<AllTopic>;
};

/** Methods to use when ordering `AllTopic`. */
export enum AllTopicsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL'
}

/** All input for the `auth` mutation. */
export type AuthInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  guid: Scalars['String'];
  lang: Scalars['String'];
  pin: Scalars['Int'];
  type: AuthType;
};

/** The output of our `auth` mutation. */
export type AuthPayload = {
  __typename?: 'AuthPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<AuthResult>;
};

/** The provider of the authentication method. */
export enum AuthProvider {
  Google = 'GOOGLE',
  Link = 'LINK'
}

/** A filter to be used against AuthProvider fields. All fields are combined with a logical ‘and.’ */
export type AuthProviderFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AuthProvider>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AuthProvider>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AuthProvider>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AuthProvider>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AuthProvider>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AuthProvider>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AuthProvider>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AuthProvider>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AuthProvider>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AuthProvider>>;
};

export type AuthRequest = Node & {
  __typename?: 'AuthRequest';
  /** The confirmed_at of the auth_request */
  confirmedAt?: Maybe<Scalars['Datetime']>;
  /** The created_at of the auth_request */
  createdAt: Scalars['Datetime'];
  /** The deleted_at of the auth_request */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** The guid of the auth_request */
  guid: Scalars['UUID'];
  /** The id of the auth_request */
  id: Scalars['Int'];
  /** The modified_at of the auth_request */
  modifiedAt?: Maybe<Scalars['Datetime']>;
  /** The modified_count of the auth_request */
  modifiedCount: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The pin of the auth_request */
  pin?: Maybe<Scalars['Int']>;
  /** The provider of the auth_request */
  provider: AuthProvider;
  /** Reads a single `EmailAddress` that is related to this `AuthRequest`. */
  userEmailAddress?: Maybe<EmailAddress>;
  /** The user_email_address_id of the auth_request */
  userEmailAddressId: Scalars['Int'];
};

/**
 * A condition to be used against `AuthRequest` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AuthRequestCondition = {
  /** Checks for equality with the object’s `confirmedAt` field. */
  confirmedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pin` field. */
  pin?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<AuthProvider>;
  /** Checks for equality with the object’s `userEmailAddressId` field. */
  userEmailAddressId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `AuthRequest` object types. All fields are combined with a logical ‘and.’ */
export type AuthRequestFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuthRequestFilter>>;
  /** Filter by the object’s `confirmedAt` field. */
  confirmedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuthRequestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuthRequestFilter>>;
  /** Filter by the object’s `pin` field. */
  pin?: InputMaybe<IntFilter>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<AuthProviderFilter>;
  /** Filter by the object’s `userEmailAddress` relation. */
  userEmailAddress?: InputMaybe<EmailAddressFilter>;
  /** Filter by the object’s `userEmailAddressId` field. */
  userEmailAddressId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `AuthRequest` values. */
export type AuthRequestsConnection = {
  __typename?: 'AuthRequestsConnection';
  /** A list of edges which contains the `AuthRequest` and cursor to aid in pagination. */
  edges: Array<AuthRequestsEdge>;
  /** A list of `AuthRequest` objects. */
  nodes: Array<Maybe<AuthRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuthRequest` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AuthRequest` edge in the connection. */
export type AuthRequestsEdge = {
  __typename?: 'AuthRequestsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AuthRequest` at the end of the edge. */
  node?: Maybe<AuthRequest>;
};

/** Methods to use when ordering `AuthRequest`. */
export enum AuthRequestsOrderBy {
  ConfirmedAtAsc = 'CONFIRMED_AT_ASC',
  ConfirmedAtDesc = 'CONFIRMED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  ModifiedCountAsc = 'MODIFIED_COUNT_ASC',
  ModifiedCountDesc = 'MODIFIED_COUNT_DESC',
  Natural = 'NATURAL',
  PinAsc = 'PIN_ASC',
  PinDesc = 'PIN_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderAsc = 'PROVIDER_ASC',
  ProviderDesc = 'PROVIDER_DESC',
  UserEmailAddressIdAsc = 'USER_EMAIL_ADDRESS_ID_ASC',
  UserEmailAddressIdDesc = 'USER_EMAIL_ADDRESS_ID_DESC'
}

/** The result of an authentication request. */
export type AuthResult = {
  __typename?: 'AuthResult';
  /** the expiration date of the token */
  expiresAt?: Maybe<Scalars['Datetime']>;
  /** true if authentication was successful */
  success?: Maybe<Scalars['Boolean']>;
  /** the token if authentication was successful */
  token?: Maybe<Scalars['JwtToken']>;
};

/** The type of authentication method. */
export enum AuthType {
  Guid = 'GUID',
  Pin = 'PIN'
}

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type Commute = {
  __typename?: 'Commute';
  bufferTime?: Maybe<Scalars['Int']>;
  from?: Maybe<CommutePart>;
  to?: Maybe<CommutePart>;
  totalCost?: Maybe<Scalars['Float']>;
  totalDistance?: Maybe<Scalars['Float']>;
  totalDuration?: Maybe<Scalars['Float']>;
};

export type CommutePart = {
  __typename?: 'CommutePart';
  cost?: Maybe<Cost>;
  costCurrency?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['Float']>;
};

export type Cost = {
  __typename?: 'Cost';
  distance?: Maybe<Scalars['Float']>;
  time?: Maybe<Scalars['Float']>;
};

/** A connection to a list of `Country` values. */
export type CountriesConnection = {
  __typename?: 'CountriesConnection';
  /** A list of edges which contains the `Country` and cursor to aid in pagination. */
  edges: Array<CountriesEdge>;
  /** A list of `Country` objects. */
  nodes: Array<Maybe<Country>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Country` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Country` edge in the connection. */
export type CountriesEdge = {
  __typename?: 'CountriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Country` at the end of the edge. */
  node?: Maybe<Country>;
};

/** Methods to use when ordering `Country`. */
export enum CountriesOrderBy {
  CaptitalAsc = 'CAPTITAL_ASC',
  CaptitalDesc = 'CAPTITAL_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyAsc = 'CURRENCY_ASC',
  CurrencyDesc = 'CURRENCY_DESC',
  CurrencyNameAsc = 'CURRENCY_NAME_ASC',
  CurrencyNameDesc = 'CURRENCY_NAME_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  EmojiAsc = 'EMOJI_ASC',
  EmojiDesc = 'EMOJI_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Iso2Asc = 'ISO2_ASC',
  Iso2Desc = 'ISO2_DESC',
  Iso3Asc = 'ISO3_ASC',
  Iso3Desc = 'ISO3_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  LatAsc = 'LAT_ASC',
  LatDesc = 'LAT_DESC',
  LngAsc = 'LNG_ASC',
  LngDesc = 'LNG_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NativeAsc = 'NATIVE_ASC',
  NativeDesc = 'NATIVE_DESC',
  Natural = 'NATURAL',
  NumericCodeAsc = 'NUMERIC_CODE_ASC',
  NumericCodeDesc = 'NUMERIC_CODE_DESC',
  PhoneCodeAsc = 'PHONE_CODE_ASC',
  PhoneCodeDesc = 'PHONE_CODE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RegionAsc = 'REGION_ASC',
  RegionDesc = 'REGION_DESC',
  SubregionAsc = 'SUBREGION_ASC',
  SubregionDesc = 'SUBREGION_DESC',
  TimezonesAsc = 'TIMEZONES_ASC',
  TimezonesDesc = 'TIMEZONES_DESC',
  TldAsc = 'TLD_ASC',
  TldDesc = 'TLD_DESC',
  TranslationsAsc = 'TRANSLATIONS_ASC',
  TranslationsDesc = 'TRANSLATIONS_DESC'
}

/** A country */
export type Country = Node & {
  __typename?: 'Country';
  /** The captital of the country */
  captital?: Maybe<Scalars['String']>;
  /** The timestamp when the country was created */
  createdAt: Scalars['Datetime'];
  /** The currency of the country */
  currency?: Maybe<Scalars['String']>;
  /** The currency name of the country */
  currencyName?: Maybe<Scalars['String']>;
  /** The timestamp when the country was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** The emoji of the country */
  emoji?: Maybe<Scalars['String']>;
  /** The globally unique identifier for the country */
  guid: Scalars['UUID'];
  /** The primary unique identifier for the country */
  id: Scalars['Int'];
  /** The flag to indicate if the country is active */
  isActive?: Maybe<Scalars['Boolean']>;
  /** The iso2 of the country */
  iso2?: Maybe<Scalars['String']>;
  /** The iso3 of the country */
  iso3?: Maybe<Scalars['String']>;
  /** The latitude of the country */
  lat?: Maybe<Scalars['String']>;
  /** The longitude of the country */
  lng?: Maybe<Scalars['String']>;
  /** The name of the country */
  name?: Maybe<Scalars['String']>;
  /** The native of the country */
  native?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The numeric code of the country */
  numericCode?: Maybe<Scalars['String']>;
  /** The phone code of the country */
  phoneCode?: Maybe<Scalars['String']>;
  /** The region of the country */
  region?: Maybe<Scalars['String']>;
  /** The subregion of the country */
  subregion?: Maybe<Scalars['String']>;
  /** The timezones of the country */
  timezones?: Maybe<Scalars['JSON']>;
  /** The tld of the country */
  tld?: Maybe<Scalars['String']>;
  /** The translations of the country */
  translations?: Maybe<Scalars['JSON']>;
};

/** A condition to be used against `Country` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CountryCondition = {
  /** Checks for equality with the object’s `captital` field. */
  captital?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `currencyName` field. */
  currencyName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `emoji` field. */
  emoji?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `iso2` field. */
  iso2?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `iso3` field. */
  iso3?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lat` field. */
  lat?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lng` field. */
  lng?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `native` field. */
  native?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `numericCode` field. */
  numericCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `phoneCode` field. */
  phoneCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `region` field. */
  region?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `subregion` field. */
  subregion?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `timezones` field. */
  timezones?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `tld` field. */
  tld?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `translations` field. */
  translations?: InputMaybe<Scalars['JSON']>;
};

/** A filter to be used against `Country` object types. All fields are combined with a logical ‘and.’ */
export type CountryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CountryFilter>>;
  /** Filter by the object’s `captital` field. */
  captital?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `currencyName` field. */
  currencyName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `emoji` field. */
  emoji?: InputMaybe<StringFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `iso2` field. */
  iso2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `iso3` field. */
  iso3?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lat` field. */
  lat?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lng` field. */
  lng?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `native` field. */
  native?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CountryFilter>;
  /** Filter by the object’s `numericCode` field. */
  numericCode?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CountryFilter>>;
  /** Filter by the object’s `phoneCode` field. */
  phoneCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `region` field. */
  region?: InputMaybe<StringFilter>;
  /** Filter by the object’s `subregion` field. */
  subregion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `timezones` field. */
  timezones?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `tld` field. */
  tld?: InputMaybe<StringFilter>;
  /** Filter by the object’s `translations` field. */
  translations?: InputMaybe<JsonFilter>;
};

/** An input for mutations affecting `Country` */
export type CountryInput = {
  /** The captital of the country */
  captital?: InputMaybe<Scalars['String']>;
  /** The currency of the country */
  currency?: InputMaybe<Scalars['String']>;
  /** The currency name of the country */
  currencyName?: InputMaybe<Scalars['String']>;
  /** The emoji of the country */
  emoji?: InputMaybe<Scalars['String']>;
  /** The flag to indicate if the country is active */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The iso2 of the country */
  iso2?: InputMaybe<Scalars['String']>;
  /** The iso3 of the country */
  iso3?: InputMaybe<Scalars['String']>;
  /** The latitude of the country */
  lat?: InputMaybe<Scalars['String']>;
  /** The longitude of the country */
  lng?: InputMaybe<Scalars['String']>;
  /** The name of the country */
  name?: InputMaybe<Scalars['String']>;
  /** The native of the country */
  native?: InputMaybe<Scalars['String']>;
  /** The numeric code of the country */
  numericCode?: InputMaybe<Scalars['String']>;
  /** The phone code of the country */
  phoneCode?: InputMaybe<Scalars['String']>;
  /** The region of the country */
  region?: InputMaybe<Scalars['String']>;
  /** The subregion of the country */
  subregion?: InputMaybe<Scalars['String']>;
  /** The timezones of the country */
  timezones?: InputMaybe<Scalars['JSON']>;
  /** The tld of the country */
  tld?: InputMaybe<Scalars['String']>;
  /** The translations of the country */
  translations?: InputMaybe<Scalars['JSON']>;
};

/** Represents an update to a `Country`. Fields that are set will be updated. */
export type CountryPatch = {
  /** The captital of the country */
  captital?: InputMaybe<Scalars['String']>;
  /** The currency of the country */
  currency?: InputMaybe<Scalars['String']>;
  /** The currency name of the country */
  currencyName?: InputMaybe<Scalars['String']>;
  /** The emoji of the country */
  emoji?: InputMaybe<Scalars['String']>;
  /** The flag to indicate if the country is active */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The iso2 of the country */
  iso2?: InputMaybe<Scalars['String']>;
  /** The iso3 of the country */
  iso3?: InputMaybe<Scalars['String']>;
  /** The latitude of the country */
  lat?: InputMaybe<Scalars['String']>;
  /** The longitude of the country */
  lng?: InputMaybe<Scalars['String']>;
  /** The name of the country */
  name?: InputMaybe<Scalars['String']>;
  /** The native of the country */
  native?: InputMaybe<Scalars['String']>;
  /** The numeric code of the country */
  numericCode?: InputMaybe<Scalars['String']>;
  /** The phone code of the country */
  phoneCode?: InputMaybe<Scalars['String']>;
  /** The region of the country */
  region?: InputMaybe<Scalars['String']>;
  /** The subregion of the country */
  subregion?: InputMaybe<Scalars['String']>;
  /** The timezones of the country */
  timezones?: InputMaybe<Scalars['JSON']>;
  /** The tld of the country */
  tld?: InputMaybe<Scalars['String']>;
  /** The translations of the country */
  translations?: InputMaybe<Scalars['JSON']>;
};

export type CreateBookingInput = {
  end: Scalars['String'];
  location: Location;
  services: Array<Scalars['Int']>;
  start: Scalars['String'];
};

export type CreateBookingResponse = {
  __typename?: 'CreateBookingResponse';
  success: Scalars['Boolean'];
  userBooking?: Maybe<UserBooking>;
};

/** All input for the create `Country` mutation. */
export type CreateCountryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Country` to be created by this mutation. */
  country: CountryInput;
};

/** The output of our create `Country` mutation. */
export type CreateCountryPayload = {
  __typename?: 'CreateCountryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Country` that was created by this mutation. */
  country?: Maybe<Country>;
  /** An edge for our `Country`. May be used by Relay 1. */
  countryEdge?: Maybe<CountriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Country` mutation. */
export type CreateCountryPayloadCountryEdgeArgs = {
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};

/** All input for the create `EmailAddress` mutation. */
export type CreateEmailAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EmailAddress` to be created by this mutation. */
  emailAddress: EmailAddressInput;
};

/** The output of our create `EmailAddress` mutation. */
export type CreateEmailAddressPayload = {
  __typename?: 'CreateEmailAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EmailAddress` that was created by this mutation. */
  emailAddress?: Maybe<EmailAddress>;
  /** An edge for our `EmailAddress`. May be used by Relay 1. */
  emailAddressEdge?: Maybe<EmailAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmailAddress`. */
  user?: Maybe<User>;
};


/** The output of our create `EmailAddress` mutation. */
export type CreateEmailAddressPayloadEmailAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailAddressesOrderBy>>;
};

export type CreateMagicLinkInput = {
  emailAddress: Scalars['String'];
  locale: Scalars['String'];
};

export type CreateMagicLinkResult = {
  __typename?: 'CreateMagicLinkResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  guid?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** All input for the create `UserBooking` mutation. */
export type CreateUserBookingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserBooking` to be created by this mutation. */
  userBooking: UserBookingInput;
};

/** The output of our create `UserBooking` mutation. */
export type CreateUserBookingPayload = {
  __typename?: 'CreateUserBookingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserBooking`. */
  user?: Maybe<User>;
  /** The `UserBooking` that was created by this mutation. */
  userBooking?: Maybe<UserBooking>;
  /** An edge for our `UserBooking`. May be used by Relay 1. */
  userBookingEdge?: Maybe<UserBookingsEdge>;
  /** Reads a single `UserZone` that is related to this `UserBooking`. */
  userZone?: Maybe<UserZone>;
};


/** The output of our create `UserBooking` mutation. */
export type CreateUserBookingPayloadUserBookingEdgeArgs = {
  orderBy?: InputMaybe<Array<UserBookingsOrderBy>>;
};

/** All input for the create `UserBookingPaymentState` mutation. */
export type CreateUserBookingPaymentStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserBookingPaymentState` to be created by this mutation. */
  userBookingPaymentState: UserBookingPaymentStateInput;
};

/** The output of our create `UserBookingPaymentState` mutation. */
export type CreateUserBookingPaymentStatePayload = {
  __typename?: 'CreateUserBookingPaymentStatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserBooking` that is related to this `UserBookingPaymentState`. */
  userBooking?: Maybe<UserBooking>;
  /** The `UserBookingPaymentState` that was created by this mutation. */
  userBookingPaymentState?: Maybe<UserBookingPaymentState>;
  /** An edge for our `UserBookingPaymentState`. May be used by Relay 1. */
  userBookingPaymentStateEdge?: Maybe<UserBookingPaymentStatesEdge>;
};


/** The output of our create `UserBookingPaymentState` mutation. */
export type CreateUserBookingPaymentStatePayloadUserBookingPaymentStateEdgeArgs = {
  orderBy?: InputMaybe<Array<UserBookingPaymentStatesOrderBy>>;
};

/** All input for the create `UserBookingState` mutation. */
export type CreateUserBookingStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserBookingState` to be created by this mutation. */
  userBookingState: UserBookingStateInput;
};

/** The output of our create `UserBookingState` mutation. */
export type CreateUserBookingStatePayload = {
  __typename?: 'CreateUserBookingStatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserBooking` that is related to this `UserBookingState`. */
  userBooking?: Maybe<UserBooking>;
  /** The `UserBookingState` that was created by this mutation. */
  userBookingState?: Maybe<UserBookingState>;
  /** An edge for our `UserBookingState`. May be used by Relay 1. */
  userBookingStateEdge?: Maybe<UserBookingStatesEdge>;
};


/** The output of our create `UserBookingState` mutation. */
export type CreateUserBookingStatePayloadUserBookingStateEdgeArgs = {
  orderBy?: InputMaybe<Array<UserBookingStatesOrderBy>>;
};

/** All input for the create `UserCalendarEntry` mutation. */
export type CreateUserCalendarEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserCalendarEntry` to be created by this mutation. */
  userCalendarEntry: UserCalendarEntryInput;
};

/** The output of our create `UserCalendarEntry` mutation. */
export type CreateUserCalendarEntryPayload = {
  __typename?: 'CreateUserCalendarEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserCalendarEntry`. */
  user?: Maybe<User>;
  /** Reads a single `UserBooking` that is related to this `UserCalendarEntry`. */
  userBooking?: Maybe<UserBooking>;
  /** The `UserCalendarEntry` that was created by this mutation. */
  userCalendarEntry?: Maybe<UserCalendarEntry>;
  /** An edge for our `UserCalendarEntry`. May be used by Relay 1. */
  userCalendarEntryEdge?: Maybe<UserCalendarEntriesEdge>;
};


/** The output of our create `UserCalendarEntry` mutation. */
export type CreateUserCalendarEntryPayloadUserCalendarEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCalendarEntriesOrderBy>>;
};

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `UserRoutingHome` mutation. */
export type CreateUserRoutingHomeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserRoutingHome` to be created by this mutation. */
  userRoutingHome: UserRoutingHomeInput;
};

/** The output of our create `UserRoutingHome` mutation. */
export type CreateUserRoutingHomePayload = {
  __typename?: 'CreateUserRoutingHomePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserRoutingHome`. */
  user?: Maybe<User>;
  /** The `UserRoutingHome` that was created by this mutation. */
  userRoutingHome?: Maybe<UserRoutingHome>;
  /** An edge for our `UserRoutingHome`. May be used by Relay 1. */
  userRoutingHomeEdge?: Maybe<UserRoutingHomesEdge>;
};


/** The output of our create `UserRoutingHome` mutation. */
export type CreateUserRoutingHomePayloadUserRoutingHomeEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRoutingHomesOrderBy>>;
};

/** All input for the create `UserService` mutation. */
export type CreateUserServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserService` to be created by this mutation. */
  userService: UserServiceInput;
};

/** The output of our create `UserService` mutation. */
export type CreateUserServicePayload = {
  __typename?: 'CreateUserServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `UserService` that is related to this `UserService`. */
  parent?: Maybe<UserService>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserService`. */
  user?: Maybe<User>;
  /** The `UserService` that was created by this mutation. */
  userService?: Maybe<UserService>;
  /** An edge for our `UserService`. May be used by Relay 1. */
  userServiceEdge?: Maybe<UserServicesEdge>;
};


/** The output of our create `UserService` mutation. */
export type CreateUserServicePayloadUserServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<UserServicesOrderBy>>;
};

/** All input for the create `UserServiceView` mutation. */
export type CreateUserServiceViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserServiceView` to be created by this mutation. */
  userServiceView: UserServiceViewInput;
};

/** The output of our create `UserServiceView` mutation. */
export type CreateUserServiceViewPayload = {
  __typename?: 'CreateUserServiceViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserServiceView` that was created by this mutation. */
  userServiceView?: Maybe<UserServiceView>;
  /** An edge for our `UserServiceView`. May be used by Relay 1. */
  userServiceViewEdge?: Maybe<UserServiceViewsEdge>;
};


/** The output of our create `UserServiceView` mutation. */
export type CreateUserServiceViewPayloadUserServiceViewEdgeArgs = {
  orderBy?: InputMaybe<Array<UserServiceViewsOrderBy>>;
};

/** All input for the `createUserZoneGeometry` mutation. */
export type CreateUserZoneGeometryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userZoneId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The output of our `createUserZoneGeometry` mutation. */
export type CreateUserZoneGeometryPayload = {
  __typename?: 'CreateUserZoneGeometryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  results?: Maybe<Array<Maybe<CreateUserZoneGeometryRecord>>>;
};

/** The return type of our `createUserZoneGeometry` mutation. */
export type CreateUserZoneGeometryRecord = {
  __typename?: 'CreateUserZoneGeometryRecord';
  id?: Maybe<Scalars['Int']>;
  newValue?: Maybe<GeometryInterface>;
  type?: Maybe<CrudType>;
  zoneId?: Maybe<Scalars['Int']>;
};

/** All input for the create `UserZone` mutation. */
export type CreateUserZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserZone` to be created by this mutation. */
  userZone: UserZoneInput;
};

/** The output of our create `UserZone` mutation. */
export type CreateUserZonePayload = {
  __typename?: 'CreateUserZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserZone`. */
  user?: Maybe<User>;
  /** The `UserZone` that was created by this mutation. */
  userZone?: Maybe<UserZone>;
  /** An edge for our `UserZone`. May be used by Relay 1. */
  userZoneEdge?: Maybe<UserZonesEdge>;
};


/** The output of our create `UserZone` mutation. */
export type CreateUserZonePayloadUserZoneEdgeArgs = {
  orderBy?: InputMaybe<Array<UserZonesOrderBy>>;
};

export enum CrudType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']>>;
};

/** All input for the `deleteAuthRequest` mutation. */
export type DeleteAuthRequestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** The output of our `deleteAuthRequest` mutation. */
export type DeleteAuthRequestPayload = {
  __typename?: 'DeleteAuthRequestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  simpleResult?: Maybe<SimpleResult>;
};

/** All input for the `deleteCountry` mutation. */
export type DeleteCountryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** The output of our `deleteCountry` mutation. */
export type DeleteCountryPayload = {
  __typename?: 'DeleteCountryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  simpleResult?: Maybe<SimpleResult>;
};

/** All input for the `deleteEmailAddress` mutation. */
export type DeleteEmailAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** The output of our `deleteEmailAddress` mutation. */
export type DeleteEmailAddressPayload = {
  __typename?: 'DeleteEmailAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<SimpleResult>;
};

/** All input for the `deleteUserBookingPaymentStateByNodeId` mutation. */
export type DeleteUserBookingPaymentStateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserBookingPaymentState` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUserBookingPaymentState` mutation. */
export type DeleteUserBookingPaymentStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Primary key */
  id: Scalars['Int'];
};

/** The output of our delete `UserBookingPaymentState` mutation. */
export type DeleteUserBookingPaymentStatePayload = {
  __typename?: 'DeleteUserBookingPaymentStatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserBookingPaymentStateNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserBooking` that is related to this `UserBookingPaymentState`. */
  userBooking?: Maybe<UserBooking>;
  /** The `UserBookingPaymentState` that was deleted by this mutation. */
  userBookingPaymentState?: Maybe<UserBookingPaymentState>;
  /** An edge for our `UserBookingPaymentState`. May be used by Relay 1. */
  userBookingPaymentStateEdge?: Maybe<UserBookingPaymentStatesEdge>;
};


/** The output of our delete `UserBookingPaymentState` mutation. */
export type DeleteUserBookingPaymentStatePayloadUserBookingPaymentStateEdgeArgs = {
  orderBy?: InputMaybe<Array<UserBookingPaymentStatesOrderBy>>;
};

/** All input for the `deleteUserBookingStateByNodeId` mutation. */
export type DeleteUserBookingStateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserBookingState` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUserBookingState` mutation. */
export type DeleteUserBookingStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Primary key */
  id: Scalars['Int'];
};

/** The output of our delete `UserBookingState` mutation. */
export type DeleteUserBookingStatePayload = {
  __typename?: 'DeleteUserBookingStatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserBookingStateNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserBooking` that is related to this `UserBookingState`. */
  userBooking?: Maybe<UserBooking>;
  /** The `UserBookingState` that was deleted by this mutation. */
  userBookingState?: Maybe<UserBookingState>;
  /** An edge for our `UserBookingState`. May be used by Relay 1. */
  userBookingStateEdge?: Maybe<UserBookingStatesEdge>;
};


/** The output of our delete `UserBookingState` mutation. */
export type DeleteUserBookingStatePayloadUserBookingStateEdgeArgs = {
  orderBy?: InputMaybe<Array<UserBookingStatesOrderBy>>;
};

/** All input for the `deleteUserCalendarEntryByNodeId` mutation. */
export type DeleteUserCalendarEntryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserCalendarEntry` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUserCalendarEntry` mutation. */
export type DeleteUserCalendarEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Primary key */
  id: Scalars['Int'];
};

/** The output of our delete `UserCalendarEntry` mutation. */
export type DeleteUserCalendarEntryPayload = {
  __typename?: 'DeleteUserCalendarEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserCalendarEntryNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserCalendarEntry`. */
  user?: Maybe<User>;
  /** Reads a single `UserBooking` that is related to this `UserCalendarEntry`. */
  userBooking?: Maybe<UserBooking>;
  /** The `UserCalendarEntry` that was deleted by this mutation. */
  userCalendarEntry?: Maybe<UserCalendarEntry>;
  /** An edge for our `UserCalendarEntry`. May be used by Relay 1. */
  userCalendarEntryEdge?: Maybe<UserCalendarEntriesEdge>;
};


/** The output of our delete `UserCalendarEntry` mutation. */
export type DeleteUserCalendarEntryPayloadUserCalendarEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCalendarEntriesOrderBy>>;
};

/** All input for the `deleteUserDevice` mutation. */
export type DeleteUserDeviceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

/** The output of our `deleteUserDevice` mutation. */
export type DeleteUserDevicePayload = {
  __typename?: 'DeleteUserDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  simpleResult?: Maybe<SimpleResult>;
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** The output of our `deleteUser` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<SimpleResult>;
};

/** All input for the `deleteUserRoutingHome` mutation. */
export type DeleteUserRoutingHomeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** The output of our `deleteUserRoutingHome` mutation. */
export type DeleteUserRoutingHomePayload = {
  __typename?: 'DeleteUserRoutingHomePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  simpleResult?: Maybe<SimpleResult>;
};

/** All input for the `deleteUserService` mutation. */
export type DeleteUserServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the `deleteUserServiceItem` mutation. */
export type DeleteUserServiceItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** The output of our `deleteUserServiceItem` mutation. */
export type DeleteUserServiceItemPayload = {
  __typename?: 'DeleteUserServiceItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  simpleResult?: Maybe<SimpleResult>;
};

/** The output of our `deleteUserService` mutation. */
export type DeleteUserServicePayload = {
  __typename?: 'DeleteUserServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  simpleResult?: Maybe<SimpleResult>;
};

/** All input for the `deleteUserZoneGeometry` mutation. */
export type DeleteUserZoneGeometryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** The output of our `deleteUserZoneGeometry` mutation. */
export type DeleteUserZoneGeometryPayload = {
  __typename?: 'DeleteUserZoneGeometryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  simpleResult?: Maybe<SimpleResult>;
};

/** All input for the `deleteUserZone` mutation. */
export type DeleteUserZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** The output of our `deleteUserZone` mutation. */
export type DeleteUserZonePayload = {
  __typename?: 'DeleteUserZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  simpleResult?: Maybe<SimpleResult>;
};

/** A users email address */
export type EmailAddress = Node & {
  __typename?: 'EmailAddress';
  /** Reads and enables pagination through a set of `AuthRequest`. */
  authRequests: AuthRequestsConnection;
  /** The timestamp when the email address was confirmed */
  confirmedAt?: Maybe<Scalars['Datetime']>;
  /** The timestamp when the user email address was created */
  createdAt: Scalars['Datetime'];
  /** The timestamp when the user email address was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** The globally unique identifier for the users email address */
  guid: Scalars['UUID'];
  /** The primary unique identifier for the users email address */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `User` that is related to this `EmailAddress`. */
  user?: Maybe<User>;
  /** The user id of the user */
  userId: Scalars['Int'];
  /** The email address of the user */
  value: Scalars['EmailAddressValue'];
};


/** A users email address */
export type EmailAddressAuthRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AuthRequestCondition>;
  filter?: InputMaybe<AuthRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthRequestsOrderBy>>;
};

/**
 * A condition to be used against `EmailAddress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EmailAddressCondition = {
  /** Checks for equality with the object’s `confirmedAt` field. */
  confirmedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['EmailAddressValue']>;
};

/** A filter to be used against `EmailAddress` object types. All fields are combined with a logical ‘and.’ */
export type EmailAddressFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmailAddressFilter>>;
  /** Filter by the object’s `authRequests` relation. */
  authRequests?: InputMaybe<EmailAddressToManyAuthRequestFilter>;
  /** Some related `authRequests` exist. */
  authRequestsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `confirmedAt` field. */
  confirmedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmailAddressFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmailAddressFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<EmailAddressValueFilter>;
};

/** An input for mutations affecting `EmailAddress` */
export type EmailAddressInput = {
  /** The user id of the user */
  userId: Scalars['Int'];
  /** The email address of the user */
  value: Scalars['EmailAddressValue'];
};

/** A filter to be used against many `AuthRequest` object types. All fields are combined with a logical ‘and.’ */
export type EmailAddressToManyAuthRequestFilter = {
  /** Every related `AuthRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthRequestFilter>;
  /** No related `AuthRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthRequestFilter>;
  /** Some related `AuthRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthRequestFilter>;
};

/** A filter to be used against EmailAddressValue fields. All fields are combined with a logical ‘and.’ */
export type EmailAddressValueFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['EmailAddressValue']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['EmailAddressValue']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['EmailAddressValue']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['EmailAddressValue']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['EmailAddressValue']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['EmailAddressValue']>;
};

/** A connection to a list of `EmailAddress` values. */
export type EmailAddressesConnection = {
  __typename?: 'EmailAddressesConnection';
  /** A list of edges which contains the `EmailAddress` and cursor to aid in pagination. */
  edges: Array<EmailAddressesEdge>;
  /** A list of `EmailAddress` objects. */
  nodes: Array<Maybe<EmailAddress>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmailAddress` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EmailAddress` edge in the connection. */
export type EmailAddressesEdge = {
  __typename?: 'EmailAddressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EmailAddress` at the end of the edge. */
  node?: Maybe<EmailAddress>;
};

/** Methods to use when ordering `EmailAddress`. */
export enum EmailAddressesOrderBy {
  ConfirmedAtAsc = 'CONFIRMED_AT_ASC',
  ConfirmedAtDesc = 'CONFIRMED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String'];
  message: Scalars['String'];
};

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

/** A filter to be used against Float List fields. All fields are combined with a logical ‘and.’ */
export type FloatListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['Float']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['Float']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['Float']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['Float']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type GeocodeInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  zipCode: Scalars['String'];
};

export type GeocodeResponse = {
  __typename?: 'GeocodeResponse';
  administrativeLevels?: Maybe<GeocodeResponseAdministrativeLevels>;
  building?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  extra?: Maybe<GeocodeResponseExtra>;
  formattedAddress?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  provider?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type GeocodeResponseAdministrativeLevels = {
  __typename?: 'GeocodeResponseAdministrativeLevels';
  level1long?: Maybe<Scalars['String']>;
  level1short?: Maybe<Scalars['String']>;
  level2long?: Maybe<Scalars['String']>;
  level2short?: Maybe<Scalars['String']>;
};

export type GeocodeResponseExtra = {
  __typename?: 'GeocodeResponseExtra';
  confidence?: Maybe<Scalars['Float']>;
  googlePlaceId?: Maybe<Scalars['String']>;
};

/** All geometry XY types implement this interface */
export type GeometryGeometry = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int'];
};

export type GeometryGeometryCollection = GeometryGeometry & GeometryInterface & {
  __typename?: 'GeometryGeometryCollection';
  geojson?: Maybe<Scalars['GeoJSON']>;
  geometries?: Maybe<Array<Maybe<GeometryGeometry>>>;
  srid: Scalars['Int'];
};

export type GeometryGeometryCollectionM = GeometryGeometryM & GeometryInterface & {
  __typename?: 'GeometryGeometryCollectionM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  geometries?: Maybe<Array<Maybe<GeometryGeometryM>>>;
  srid: Scalars['Int'];
};

export type GeometryGeometryCollectionZ = GeometryGeometryZ & GeometryInterface & {
  __typename?: 'GeometryGeometryCollectionZ';
  geojson?: Maybe<Scalars['GeoJSON']>;
  geometries?: Maybe<Array<Maybe<GeometryGeometryZ>>>;
  srid: Scalars['Int'];
};

export type GeometryGeometryCollectionZm = GeometryGeometryZm & GeometryInterface & {
  __typename?: 'GeometryGeometryCollectionZM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  geometries?: Maybe<Array<Maybe<GeometryGeometryZm>>>;
  srid: Scalars['Int'];
};

/** All geometry XYM types implement this interface */
export type GeometryGeometryM = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int'];
};

/** All geometry XYZ types implement this interface */
export type GeometryGeometryZ = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int'];
};

/** All geometry XYZM types implement this interface */
export type GeometryGeometryZm = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int'];
};

/** All geometry types implement this interface */
export type GeometryInterface = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int'];
};

export type GeometryLineString = GeometryGeometry & GeometryInterface & {
  __typename?: 'GeometryLineString';
  geojson?: Maybe<Scalars['GeoJSON']>;
  points?: Maybe<Array<Maybe<GeometryPoint>>>;
  srid: Scalars['Int'];
};

export type GeometryLineStringM = GeometryGeometryM & GeometryInterface & {
  __typename?: 'GeometryLineStringM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  points?: Maybe<Array<Maybe<GeometryPointM>>>;
  srid: Scalars['Int'];
};

export type GeometryLineStringZ = GeometryGeometryZ & GeometryInterface & {
  __typename?: 'GeometryLineStringZ';
  geojson?: Maybe<Scalars['GeoJSON']>;
  points?: Maybe<Array<Maybe<GeometryPointZ>>>;
  srid: Scalars['Int'];
};

export type GeometryLineStringZm = GeometryGeometryZm & GeometryInterface & {
  __typename?: 'GeometryLineStringZM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  points?: Maybe<Array<Maybe<GeometryPointZm>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiLineString = GeometryGeometry & GeometryInterface & {
  __typename?: 'GeometryMultiLineString';
  geojson?: Maybe<Scalars['GeoJSON']>;
  lines?: Maybe<Array<Maybe<GeometryLineString>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiLineStringM = GeometryGeometryM & GeometryInterface & {
  __typename?: 'GeometryMultiLineStringM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  lines?: Maybe<Array<Maybe<GeometryLineStringM>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiLineStringZ = GeometryGeometryZ & GeometryInterface & {
  __typename?: 'GeometryMultiLineStringZ';
  geojson?: Maybe<Scalars['GeoJSON']>;
  lines?: Maybe<Array<Maybe<GeometryLineStringZ>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiLineStringZm = GeometryGeometryZm & GeometryInterface & {
  __typename?: 'GeometryMultiLineStringZM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  lines?: Maybe<Array<Maybe<GeometryLineStringZm>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiPoint = GeometryGeometry & GeometryInterface & {
  __typename?: 'GeometryMultiPoint';
  geojson?: Maybe<Scalars['GeoJSON']>;
  points?: Maybe<Array<Maybe<GeometryPoint>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiPointM = GeometryGeometryM & GeometryInterface & {
  __typename?: 'GeometryMultiPointM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  points?: Maybe<Array<Maybe<GeometryPointM>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiPointZ = GeometryGeometryZ & GeometryInterface & {
  __typename?: 'GeometryMultiPointZ';
  geojson?: Maybe<Scalars['GeoJSON']>;
  points?: Maybe<Array<Maybe<GeometryPointZ>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiPointZm = GeometryGeometryZm & GeometryInterface & {
  __typename?: 'GeometryMultiPointZM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  points?: Maybe<Array<Maybe<GeometryPointZm>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiPolygon = GeometryGeometry & GeometryInterface & {
  __typename?: 'GeometryMultiPolygon';
  geojson?: Maybe<Scalars['GeoJSON']>;
  polygons?: Maybe<Array<Maybe<GeometryPolygon>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiPolygonM = GeometryGeometryM & GeometryInterface & {
  __typename?: 'GeometryMultiPolygonM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  polygons?: Maybe<Array<Maybe<GeometryPolygonM>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiPolygonZ = GeometryGeometryZ & GeometryInterface & {
  __typename?: 'GeometryMultiPolygonZ';
  geojson?: Maybe<Scalars['GeoJSON']>;
  polygons?: Maybe<Array<Maybe<GeometryPolygonZ>>>;
  srid: Scalars['Int'];
};

export type GeometryMultiPolygonZm = GeometryGeometryZm & GeometryInterface & {
  __typename?: 'GeometryMultiPolygonZM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  polygons?: Maybe<Array<Maybe<GeometryPolygonZm>>>;
  srid: Scalars['Int'];
};

export type GeometryPoint = GeometryGeometry & GeometryInterface & {
  __typename?: 'GeometryPoint';
  geojson?: Maybe<Scalars['GeoJSON']>;
  srid: Scalars['Int'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type GeometryPointM = GeometryGeometryM & GeometryInterface & {
  __typename?: 'GeometryPointM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  srid: Scalars['Int'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type GeometryPointZ = GeometryGeometryZ & GeometryInterface & {
  __typename?: 'GeometryPointZ';
  geojson?: Maybe<Scalars['GeoJSON']>;
  srid: Scalars['Int'];
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

export type GeometryPointZm = GeometryGeometryZm & GeometryInterface & {
  __typename?: 'GeometryPointZM';
  geojson?: Maybe<Scalars['GeoJSON']>;
  srid: Scalars['Int'];
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

export type GeometryPolygon = GeometryGeometry & GeometryInterface & {
  __typename?: 'GeometryPolygon';
  exterior?: Maybe<GeometryLineString>;
  geojson?: Maybe<Scalars['GeoJSON']>;
  interiors?: Maybe<Array<Maybe<GeometryLineString>>>;
  srid: Scalars['Int'];
};

export type GeometryPolygonM = GeometryGeometryM & GeometryInterface & {
  __typename?: 'GeometryPolygonM';
  exterior?: Maybe<GeometryLineStringM>;
  geojson?: Maybe<Scalars['GeoJSON']>;
  interiors?: Maybe<Array<Maybe<GeometryLineStringM>>>;
  srid: Scalars['Int'];
};

export type GeometryPolygonZ = GeometryGeometryZ & GeometryInterface & {
  __typename?: 'GeometryPolygonZ';
  exterior?: Maybe<GeometryLineStringZ>;
  geojson?: Maybe<Scalars['GeoJSON']>;
  interiors?: Maybe<Array<Maybe<GeometryLineStringZ>>>;
  srid: Scalars['Int'];
};

export type GeometryPolygonZm = GeometryGeometryZm & GeometryInterface & {
  __typename?: 'GeometryPolygonZM';
  exterior?: Maybe<GeometryLineStringZm>;
  geojson?: Maybe<Scalars['GeoJSON']>;
  interiors?: Maybe<Array<Maybe<GeometryLineStringZm>>>;
  srid: Scalars['Int'];
};

export type GetPossibleAppointmentsInput = {
  day?: InputMaybe<Scalars['String']>;
  location: Location;
  services: Array<Scalars['Int']>;
};

export type Holiday = {
  __typename?: 'Holiday';
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** An input for mutations affecting `Holiday` */
export type HolidayInput = {
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Holidayvalue = {
  __typename?: 'Holidayvalue';
  days?: Maybe<Array<Maybe<Scalars['Int']>>>;
  holidays?: Maybe<Array<Maybe<Holiday>>>;
};

/** An input for mutations affecting `Holidayvalue` */
export type HolidayvalueInput = {
  days?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  holidays?: InputMaybe<Array<InputMaybe<HolidayInput>>>;
};

export type InitAuthInput = {
  emailAddress: Scalars['String'];
  lang: Scalars['String'];
};

export type InitAuthPayload = {
  __typename?: 'InitAuthPayload';
  success: Scalars['Boolean'];
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

/** A filter to be used against Int List fields. All fields are combined with a logical ‘and.’ */
export type IntListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['Int']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['Int']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['Int']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['Int']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']>;
};

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']>>;
};

export type Location = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Authenticates a user and returns a token if successful. */
  auth?: Maybe<AuthPayload>;
  createBooking?: Maybe<CreateBookingResponse>;
  /** Creates a single `Country`. */
  createCountry?: Maybe<CreateCountryPayload>;
  /** Creates a single `EmailAddress`. */
  createEmailAddress?: Maybe<CreateEmailAddressPayload>;
  createMagicLink?: Maybe<CreateMagicLinkResult>;
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `UserBooking`. */
  createUserBooking?: Maybe<CreateUserBookingPayload>;
  /** Creates a single `UserBookingPaymentState`. */
  createUserBookingPaymentState?: Maybe<CreateUserBookingPaymentStatePayload>;
  /** Creates a single `UserBookingState`. */
  createUserBookingState?: Maybe<CreateUserBookingStatePayload>;
  /** Creates a single `UserCalendarEntry`. */
  createUserCalendarEntry?: Maybe<CreateUserCalendarEntryPayload>;
  /** Creates a single `UserRoutingHome`. */
  createUserRoutingHome?: Maybe<CreateUserRoutingHomePayload>;
  /** Creates a single `UserService`. */
  createUserService?: Maybe<CreateUserServicePayload>;
  /** Creates a single `UserServiceView`. */
  createUserServiceView?: Maybe<CreateUserServiceViewPayload>;
  /** Creates a single `UserZone`. */
  createUserZone?: Maybe<CreateUserZonePayload>;
  createUserZoneGeometry?: Maybe<CreateUserZoneGeometryPayload>;
  deleteAuthRequest?: Maybe<DeleteAuthRequestPayload>;
  deleteCountry?: Maybe<DeleteCountryPayload>;
  /** Deletes a users email address */
  deleteEmailAddress?: Maybe<DeleteEmailAddressPayload>;
  /** Deletes a country */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `UserBookingPaymentState` using a unique key. */
  deleteUserBookingPaymentState?: Maybe<DeleteUserBookingPaymentStatePayload>;
  /** Deletes a single `UserBookingPaymentState` using its globally unique id. */
  deleteUserBookingPaymentStateByNodeId?: Maybe<DeleteUserBookingPaymentStatePayload>;
  /** Deletes a single `UserBookingState` using a unique key. */
  deleteUserBookingState?: Maybe<DeleteUserBookingStatePayload>;
  /** Deletes a single `UserBookingState` using its globally unique id. */
  deleteUserBookingStateByNodeId?: Maybe<DeleteUserBookingStatePayload>;
  /** Deletes a single `UserCalendarEntry` using a unique key. */
  deleteUserCalendarEntry?: Maybe<DeleteUserCalendarEntryPayload>;
  /** Deletes a single `UserCalendarEntry` using its globally unique id. */
  deleteUserCalendarEntryByNodeId?: Maybe<DeleteUserCalendarEntryPayload>;
  deleteUserDevice?: Maybe<DeleteUserDevicePayload>;
  deleteUserRoutingHome?: Maybe<DeleteUserRoutingHomePayload>;
  deleteUserService?: Maybe<DeleteUserServicePayload>;
  deleteUserServiceItem?: Maybe<DeleteUserServiceItemPayload>;
  deleteUserZone?: Maybe<DeleteUserZonePayload>;
  deleteUserZoneGeometry?: Maybe<DeleteUserZoneGeometryPayload>;
  geocode?: Maybe<Array<Maybe<GeocodeResponse>>>;
  initAuth?: Maybe<InitAuthPayload>;
  notifyUser?: Maybe<NotifyUserResponse>;
  reverseGeocode?: Maybe<Array<Maybe<GeocodeResponse>>>;
  splitGeometryCollection?: Maybe<SplitGeometryCollectionPayload>;
  /** Subscribe to a topic */
  subscribe?: Maybe<SubscribePayload>;
  subscribeToNewsletter?: Maybe<NewsletterSubscribeResult>;
  /** Unsubscribe from a topic */
  unsubscribe?: Maybe<UnsubscribePayload>;
  /** Updates a single `Country` using a unique key and a patch. */
  updateCountry?: Maybe<UpdateCountryPayload>;
  /** Updates a single `Country` using its globally unique id and a patch. */
  updateCountryByNodeId?: Maybe<UpdateCountryPayload>;
  updateGeometryZone?: Maybe<UpdateGeometryZonePayload>;
  /** Updates a single `UserService` using a unique key and a patch. */
  updateUserService?: Maybe<UpdateUserServicePayload>;
  /** Updates a single `UserService` using its globally unique id and a patch. */
  updateUserServiceByNodeId?: Maybe<UpdateUserServicePayload>;
  updateUserServiceIndex?: Maybe<UpdateUserServiceIndexPayload>;
  /** Updates a single `UserZone` using a unique key and a patch. */
  updateUserZone?: Maybe<UpdateUserZonePayload>;
  /** Updates a single `UserZone` using its globally unique id and a patch. */
  updateUserZoneByNodeId?: Maybe<UpdateUserZonePayload>;
  updateUserZoneGeometry?: Maybe<UpdateUserZoneGeometryPayload>;
  /** Upserts a single `UserDevice`. */
  upsertUserDevice?: Maybe<UpsertUserDevicePayload>;
  /** Upserts a single `UserService`. */
  upsertUserService?: Maybe<UpsertUserServicePayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAuthArgs = {
  input: AuthInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBookingArgs = {
  input?: InputMaybe<CreateBookingInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCountryArgs = {
  input: CreateCountryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmailAddressArgs = {
  input: CreateEmailAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMagicLinkArgs = {
  input: CreateMagicLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserBookingArgs = {
  input: CreateUserBookingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserBookingPaymentStateArgs = {
  input: CreateUserBookingPaymentStateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserBookingStateArgs = {
  input: CreateUserBookingStateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserCalendarEntryArgs = {
  input: CreateUserCalendarEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserRoutingHomeArgs = {
  input: CreateUserRoutingHomeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserServiceArgs = {
  input: CreateUserServiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserServiceViewArgs = {
  input: CreateUserServiceViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserZoneArgs = {
  input: CreateUserZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserZoneGeometryArgs = {
  input: CreateUserZoneGeometryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuthRequestArgs = {
  input: DeleteAuthRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCountryArgs = {
  input: DeleteCountryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailAddressArgs = {
  input: DeleteEmailAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserBookingPaymentStateArgs = {
  input: DeleteUserBookingPaymentStateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserBookingPaymentStateByNodeIdArgs = {
  input: DeleteUserBookingPaymentStateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserBookingStateArgs = {
  input: DeleteUserBookingStateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserBookingStateByNodeIdArgs = {
  input: DeleteUserBookingStateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserCalendarEntryArgs = {
  input: DeleteUserCalendarEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserCalendarEntryByNodeIdArgs = {
  input: DeleteUserCalendarEntryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserDeviceArgs = {
  input: DeleteUserDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRoutingHomeArgs = {
  input: DeleteUserRoutingHomeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserServiceArgs = {
  input: DeleteUserServiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserServiceItemArgs = {
  input: DeleteUserServiceItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserZoneArgs = {
  input: DeleteUserZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserZoneGeometryArgs = {
  input: DeleteUserZoneGeometryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGeocodeArgs = {
  input?: InputMaybe<GeocodeInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInitAuthArgs = {
  input: InitAuthInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationNotifyUserArgs = {
  input: NotifyUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationReverseGeocodeArgs = {
  input?: InputMaybe<ReverseGeocodeInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSplitGeometryCollectionArgs = {
  input: SplitGeometryCollectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSubscribeArgs = {
  input: SubscribeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSubscribeToNewsletterArgs = {
  input: NewsletterSubscribeRequest;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnsubscribeArgs = {
  input: UnsubscribeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCountryArgs = {
  input: UpdateCountryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCountryByNodeIdArgs = {
  input: UpdateCountryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGeometryZoneArgs = {
  input: UpdateGeometryZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserServiceArgs = {
  input: UpdateUserServiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserServiceByNodeIdArgs = {
  input: UpdateUserServiceByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserServiceIndexArgs = {
  input: UpdateUserServiceIndexInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserZoneArgs = {
  input: UpdateUserZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserZoneByNodeIdArgs = {
  input: UpdateUserZoneByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserZoneGeometryArgs = {
  input: UpdateUserZoneGeometryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUserDeviceArgs = {
  input: UpsertUserDeviceInput;
  where?: InputMaybe<UpsertUserDeviceWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUserServiceArgs = {
  input: UpsertUserServiceInput;
  where?: InputMaybe<UpsertUserServiceWhere>;
};

export type NewsletterSubscribeRequest = {
  emailAddress: Scalars['String'];
  locale: Scalars['String'];
};

export type NewsletterSubscribeResult = {
  __typename?: 'NewsletterSubscribeResult';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

export type NotifyUserInput = {
  payload?: InputMaybe<Scalars['JSON']>;
  receiver?: InputMaybe<Scalars['ID']>;
};

export type NotifyUserResponse = {
  __typename?: 'NotifyUserResponse';
  success: Scalars['Boolean'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type PossibleAppointment = {
  __typename?: 'PossibleAppointment';
  commute?: Maybe<Commute>;
  cost?: Maybe<Scalars['Float']>;
  service?: Maybe<Service>;
  serviceEnd?: Maybe<Scalars['String']>;
  serviceStart?: Maybe<Scalars['String']>;
  totalDuration?: Maybe<Scalars['Float']>;
};

export type PossibleAppointmentResponse = {
  __typename?: 'PossibleAppointmentResponse';
  count: Scalars['Int'];
  result?: Maybe<Array<Maybe<PossibleAppointment>>>;
};

export type Price = {
  __typename?: 'Price';
  amount?: Maybe<Scalars['BigFloat']>;
  currency?: Maybe<Scalars['String']>;
};

/** A filter to be used against `Price` object types. All fields are combined with a logical ‘and.’ */
export type PriceFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PriceFilter>>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PriceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PriceFilter>>;
};

/** An input for mutations affecting `Price` */
export type PriceInput = {
  amount?: InputMaybe<Scalars['BigFloat']>;
  currency?: InputMaybe<Scalars['String']>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads and enables pagination through a set of `AllTopic`. */
  allTopics?: Maybe<AllTopicsConnection>;
  authRequest?: Maybe<AuthRequest>;
  /** Reads a single `AuthRequest` using its globally unique `ID`. */
  authRequestByNodeId?: Maybe<AuthRequest>;
  /** Reads and enables pagination through a set of `AuthRequest`. */
  authRequests?: Maybe<AuthRequestsConnection>;
  /** Reads and enables pagination through a set of `Country`. */
  countries?: Maybe<CountriesConnection>;
  country?: Maybe<Country>;
  /** Reads a single `Country` using its globally unique `ID`. */
  countryByNodeId?: Maybe<Country>;
  emailAddress?: Maybe<EmailAddress>;
  /** Reads a single `EmailAddress` using its globally unique `ID`. */
  emailAddressByNodeId?: Maybe<EmailAddress>;
  /** Reads and enables pagination through a set of `EmailAddress`. */
  emailAddresses?: Maybe<EmailAddressesConnection>;
  getPossibleAppointments?: Maybe<PossibleAppointmentResponse>;
  me?: Maybe<User>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  serverTime?: Maybe<ServerTimeResponse>;
  subscription?: Maybe<Subscription>;
  /** Reads a single `Subscription` using its globally unique `ID`. */
  subscriptionByNodeId?: Maybe<Subscription>;
  /** Reads and enables pagination through a set of `Subscription`. */
  subscriptions?: Maybe<SubscriptionsConnection>;
  user?: Maybe<User>;
  userBooking?: Maybe<UserBooking>;
  /** Reads a single `UserBooking` using its globally unique `ID`. */
  userBookingByNodeId?: Maybe<UserBooking>;
  userBookingPaymentState?: Maybe<UserBookingPaymentState>;
  /** Reads a single `UserBookingPaymentState` using its globally unique `ID`. */
  userBookingPaymentStateByNodeId?: Maybe<UserBookingPaymentState>;
  /** Reads and enables pagination through a set of `UserBookingPaymentState`. */
  userBookingPaymentStates?: Maybe<UserBookingPaymentStatesConnection>;
  userBookingState?: Maybe<UserBookingState>;
  /** Reads a single `UserBookingState` using its globally unique `ID`. */
  userBookingStateByNodeId?: Maybe<UserBookingState>;
  /** Reads and enables pagination through a set of `UserBookingState`. */
  userBookingStates?: Maybe<UserBookingStatesConnection>;
  /** Reads and enables pagination through a set of `UserBooking`. */
  userBookings?: Maybe<UserBookingsConnection>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserCalendarEntry`. */
  userCalendarEntries?: Maybe<UserCalendarEntriesConnection>;
  userCalendarEntry?: Maybe<UserCalendarEntry>;
  /** Reads a single `UserCalendarEntry` using its globally unique `ID`. */
  userCalendarEntryByNodeId?: Maybe<UserCalendarEntry>;
  userDevice?: Maybe<UserDevice>;
  /** Reads a single `UserDevice` using its globally unique `ID`. */
  userDeviceByNodeId?: Maybe<UserDevice>;
  /** Reads and enables pagination through a set of `UserDevice`. */
  userDevices?: Maybe<UserDevicesConnection>;
  userRoutingHome?: Maybe<UserRoutingHome>;
  /** Reads a single `UserRoutingHome` using its globally unique `ID`. */
  userRoutingHomeByNodeId?: Maybe<UserRoutingHome>;
  /** Reads and enables pagination through a set of `UserRoutingHome`. */
  userRoutingHomes?: Maybe<UserRoutingHomesConnection>;
  userService?: Maybe<UserService>;
  /** Reads a single `UserService` using its globally unique `ID`. */
  userServiceByNodeId?: Maybe<UserService>;
  /** Reads and enables pagination through a set of `UserServiceView`. */
  userServiceViews?: Maybe<UserServiceViewsConnection>;
  /** Reads and enables pagination through a set of `UserService`. */
  userServices?: Maybe<UserServicesConnection>;
  userZone?: Maybe<UserZone>;
  /** Reads a single `UserZone` using its globally unique `ID`. */
  userZoneByNodeId?: Maybe<UserZone>;
  /** Reads and enables pagination through a set of `UserZoneGeometry`. */
  userZoneGeometries?: Maybe<UserZoneGeometriesConnection>;
  userZoneGeometry?: Maybe<UserZoneGeometry>;
  /** Reads a single `UserZoneGeometry` using its globally unique `ID`. */
  userZoneGeometryByNodeId?: Maybe<UserZoneGeometry>;
  /** Reads and enables pagination through a set of `UserZone`. */
  userZones?: Maybe<UserZonesConnection>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTopicsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllTopicCondition>;
  filter?: InputMaybe<AllTopicFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllTopicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthRequestArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthRequestByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AuthRequestCondition>;
  filter?: InputMaybe<AuthRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthRequestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCountriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CountryCondition>;
  filter?: InputMaybe<CountryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCountryArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCountryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailAddressArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailAddressByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmailAddressCondition>;
  filter?: InputMaybe<EmailAddressFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmailAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPossibleAppointmentsArgs = {
  input?: InputMaybe<GetPossibleAppointmentsInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySubscriptionArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySubscriptionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SubscriptionCondition>;
  filter?: InputMaybe<SubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserBookingArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserBookingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserBookingPaymentStateArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserBookingPaymentStateByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserBookingPaymentStatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserBookingPaymentStateCondition>;
  filter?: InputMaybe<UserBookingPaymentStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBookingPaymentStatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserBookingStateArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserBookingStateByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserBookingStatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserBookingStateCondition>;
  filter?: InputMaybe<UserBookingStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBookingStatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserBookingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserBookingCondition>;
  filter?: InputMaybe<UserBookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBookingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCalendarEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCalendarEntryCondition>;
  filter?: InputMaybe<UserCalendarEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCalendarEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCalendarEntryArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCalendarEntryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserDeviceArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserDeviceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDeviceCondition>;
  filter?: InputMaybe<UserDeviceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDevicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoutingHomeArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoutingHomeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoutingHomesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserRoutingHomeCondition>;
  filter?: InputMaybe<UserRoutingHomeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRoutingHomesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserServiceArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserServiceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserServiceViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserServiceViewCondition>;
  filter?: InputMaybe<UserServiceViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserServiceViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserServicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserServiceCondition>;
  filter?: InputMaybe<UserServiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserServicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserZoneArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserZoneByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserZoneGeometriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserZoneGeometryCondition>;
  filter?: InputMaybe<UserZoneGeometryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserZoneGeometriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserZoneGeometryArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserZoneGeometryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserZonesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserZoneCondition>;
  filter?: InputMaybe<UserZoneFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserZonesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type ReverseGeocodeInput = {
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
};

export enum Role {
  Admin = 'ADMIN',
  User = 'USER'
}

/** A filter to be used against Role fields. All fields are combined with a logical ‘and.’ */
export type RoleFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Role>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Role>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Role>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Role>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Role>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Role>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Role>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Role>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Role>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Role>>;
};

export type Route = {
  __typename?: 'Route';
  bbox?: Maybe<Array<Maybe<Scalars['Float']>>>;
  geometry?: Maybe<Scalars['String']>;
  segments?: Maybe<Array<Maybe<RouteSegment>>>;
  summary?: Maybe<RouteSummary>;
  wayPoints?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

/** A filter to be used against `Route` object types. All fields are combined with a logical ‘and.’ */
export type RouteFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RouteFilter>>;
  /** Filter by the object’s `bbox` field. */
  bbox?: InputMaybe<FloatListFilter>;
  /** Filter by the object’s `geometry` field. */
  geometry?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RouteFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RouteFilter>>;
  /** Filter by the object’s `summary` field. */
  summary?: InputMaybe<RouteSummaryFilter>;
  /** Filter by the object’s `wayPoints` field. */
  wayPoints?: InputMaybe<IntListFilter>;
};

/** An input for mutations affecting `Route` */
export type RouteInput = {
  bbox?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  geometry?: InputMaybe<Scalars['String']>;
  segments?: InputMaybe<Array<InputMaybe<RouteSegmentInput>>>;
  summary?: InputMaybe<RouteSummaryInput>;
  wayPoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type RouteSegment = {
  __typename?: 'RouteSegment';
  distance?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  steps?: Maybe<Array<Maybe<RouteStep>>>;
};

/** An input for mutations affecting `RouteSegment` */
export type RouteSegmentInput = {
  distance?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  steps?: InputMaybe<Array<InputMaybe<RouteStepInput>>>;
};

export type RouteStep = {
  __typename?: 'RouteStep';
  distance?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  instruction?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  wayPoints?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

/** An input for mutations affecting `RouteStep` */
export type RouteStepInput = {
  distance?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  instruction?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
  wayPoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type RouteSummary = {
  __typename?: 'RouteSummary';
  distance?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** A filter to be used against `RouteSummary` object types. All fields are combined with a logical ‘and.’ */
export type RouteSummaryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RouteSummaryFilter>>;
  /** Filter by the object’s `distance` field. */
  distance?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RouteSummaryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RouteSummaryFilter>>;
};

/** An input for mutations affecting `RouteSummary` */
export type RouteSummaryInput = {
  distance?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
};

export type Rruleeditorxvalue = {
  __typename?: 'Rruleeditorxvalue';
  holiday?: Maybe<Holidayvalue>;
  rule?: Maybe<Scalars['String']>;
};

/** An input for mutations affecting `Rruleeditorxvalue` */
export type RruleeditorxvalueInput = {
  holiday?: InputMaybe<HolidayvalueInput>;
  rule?: InputMaybe<Scalars['String']>;
};

export type ServerTimeResponse = {
  __typename?: 'ServerTimeResponse';
  value: Scalars['Date'];
};

export type Service = {
  __typename?: 'Service';
  cost?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
};

export type SimpleResult = {
  __typename?: 'SimpleResult';
  /** Whether the operation was successful */
  success?: Maybe<Scalars['Boolean']>;
};

/** All input for the `splitGeometryCollection` mutation. */
export type SplitGeometryCollectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  geom?: InputMaybe<Scalars['GeoJSON']>;
};

/** The output of our `splitGeometryCollection` mutation. */
export type SplitGeometryCollectionPayload = {
  __typename?: 'SplitGeometryCollectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  geometryInterfaces?: Maybe<Array<Maybe<GeometryInterface>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']>;
};

/** All input for the `subscribe` mutation. */
export type SubscribeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Topic>;
  userDeviceId?: InputMaybe<Scalars['String']>;
};

/** The output of our `subscribe` mutation. */
export type SubscribePayload = {
  __typename?: 'SubscribePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  simpleResult?: Maybe<SimpleResult>;
};

/** Table to store user device subscriptions */
export type Subscription = Node & {
  __typename?: 'Subscription';
  /** Creation date */
  createdAt: Scalars['Datetime'];
  /** Deletion date */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Unique identifier */
  guid: Scalars['UUID'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Topic */
  topic: Topic;
  /** Reads a single `UserDevice` that is related to this `Subscription`. */
  userDevice?: Maybe<UserDevice>;
  /** User device id */
  userDeviceId: Scalars['String'];
};

/**
 * A condition to be used against `Subscription` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SubscriptionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `topic` field. */
  topic?: InputMaybe<Topic>;
  /** Checks for equality with the object’s `userDeviceId` field. */
  userDeviceId?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Subscription` object types. All fields are combined with a logical ‘and.’ */
export type SubscriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SubscriptionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SubscriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SubscriptionFilter>>;
  /** Filter by the object’s `topic` field. */
  topic?: InputMaybe<TopicFilter>;
  /** Filter by the object’s `userDevice` relation. */
  userDevice?: InputMaybe<UserDeviceFilter>;
  /** Filter by the object’s `userDeviceId` field. */
  userDeviceId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `Subscription` values. */
export type SubscriptionsConnection = {
  __typename?: 'SubscriptionsConnection';
  /** A list of edges which contains the `Subscription` and cursor to aid in pagination. */
  edges: Array<SubscriptionsEdge>;
  /** A list of `Subscription` objects. */
  nodes: Array<Maybe<Subscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Subscription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Subscription` edge in the connection. */
export type SubscriptionsEdge = {
  __typename?: 'SubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Subscription` at the end of the edge. */
  node?: Maybe<Subscription>;
};

/** Methods to use when ordering `Subscription`. */
export enum SubscriptionsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TopicAsc = 'TOPIC_ASC',
  TopicDesc = 'TOPIC_DESC',
  UserDeviceIdAsc = 'USER_DEVICE_ID_ASC',
  UserDeviceIdDesc = 'USER_DEVICE_ID_DESC'
}

export type Timesandrule = {
  __typename?: 'Timesandrule';
  exrules?: Maybe<Array<Maybe<Rruleeditorxvalue>>>;
  rules?: Maybe<Array<Maybe<Rruleeditorxvalue>>>;
  times?: Maybe<Array<Maybe<Timespan>>>;
};

/** An input for mutations affecting `Timesandrule` */
export type TimesandruleInput = {
  exrules?: InputMaybe<Array<InputMaybe<RruleeditorxvalueInput>>>;
  rules?: InputMaybe<Array<InputMaybe<RruleeditorxvalueInput>>>;
  times?: InputMaybe<Array<InputMaybe<TimespanInput>>>;
};

export type Timespan = {
  __typename?: 'Timespan';
  end?: Maybe<Scalars['Time']>;
  start?: Maybe<Scalars['Time']>;
};

/** An input for mutations affecting `Timespan` */
export type TimespanInput = {
  end?: InputMaybe<Scalars['Time']>;
  start?: InputMaybe<Scalars['Time']>;
};

export enum Topic {
  General = 'GENERAL'
}

/** A filter to be used against Topic fields. All fields are combined with a logical ‘and.’ */
export type TopicFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Topic>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Topic>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Topic>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Topic>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Topic>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Topic>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Topic>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Topic>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Topic>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Topic>>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']>>;
};

/** All input for the `unsubscribe` mutation. */
export type UnsubscribeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Topic>;
  userDeviceId?: InputMaybe<Scalars['String']>;
};

/** The output of our `unsubscribe` mutation. */
export type UnsubscribePayload = {
  __typename?: 'UnsubscribePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  simpleResult?: Maybe<SimpleResult>;
};

/** All input for the `updateCountryByNodeId` mutation. */
export type UpdateCountryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Country` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Country` being updated. */
  patch: CountryPatch;
};

/** All input for the `updateCountry` mutation. */
export type UpdateCountryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The primary unique identifier for the country */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Country` being updated. */
  patch: CountryPatch;
};

/** The output of our update `Country` mutation. */
export type UpdateCountryPayload = {
  __typename?: 'UpdateCountryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Country` that was updated by this mutation. */
  country?: Maybe<Country>;
  /** An edge for our `Country`. May be used by Relay 1. */
  countryEdge?: Maybe<CountriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Country` mutation. */
export type UpdateCountryPayloadCountryEdgeArgs = {
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};

/** All input for the `updateGeometryZone` mutation. */
export type UpdateGeometryZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  zoneId?: InputMaybe<Scalars['Int']>;
};

/** The output of our `updateGeometryZone` mutation. */
export type UpdateGeometryZonePayload = {
  __typename?: 'UpdateGeometryZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserZone` that is related to this `UserZoneGeometry`. */
  userZone?: Maybe<UserZone>;
  userZoneGeometry?: Maybe<UserZoneGeometry>;
  /** An edge for our `UserZoneGeometry`. May be used by Relay 1. */
  userZoneGeometryEdge?: Maybe<UserZoneGeometriesEdge>;
};


/** The output of our `updateGeometryZone` mutation. */
export type UpdateGeometryZonePayloadUserZoneGeometryEdgeArgs = {
  orderBy?: InputMaybe<Array<UserZoneGeometriesOrderBy>>;
};

/** All input for the `updateUserServiceByNodeId` mutation. */
export type UpdateUserServiceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserService` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UserService` being updated. */
  patch: UserServicePatch;
};

/** All input for the `updateUserServiceIndex` mutation. */
export type UpdateUserServiceIndexInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  newindex?: InputMaybe<Scalars['Int']>;
};

/** The output of our `updateUserServiceIndex` mutation. */
export type UpdateUserServiceIndexPayload = {
  __typename?: 'UpdateUserServiceIndexPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  simpleResult?: Maybe<SimpleResult>;
};

/** All input for the `updateUserService` mutation. */
export type UpdateUserServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Primary Key */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `UserService` being updated. */
  patch: UserServicePatch;
};

/** The output of our update `UserService` mutation. */
export type UpdateUserServicePayload = {
  __typename?: 'UpdateUserServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `UserService` that is related to this `UserService`. */
  parent?: Maybe<UserService>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserService`. */
  user?: Maybe<User>;
  /** The `UserService` that was updated by this mutation. */
  userService?: Maybe<UserService>;
  /** An edge for our `UserService`. May be used by Relay 1. */
  userServiceEdge?: Maybe<UserServicesEdge>;
};


/** The output of our update `UserService` mutation. */
export type UpdateUserServicePayloadUserServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<UserServicesOrderBy>>;
};

/** All input for the `updateUserZoneByNodeId` mutation. */
export type UpdateUserZoneByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserZone` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UserZone` being updated. */
  patch: UserZonePatch;
};

/** All input for the `updateUserZoneGeometry` mutation. */
export type UpdateUserZoneGeometryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  geometryId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The output of our `updateUserZoneGeometry` mutation. */
export type UpdateUserZoneGeometryPayload = {
  __typename?: 'UpdateUserZoneGeometryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  results?: Maybe<Array<Maybe<UserZoneGeometryResult>>>;
};

/** All input for the `updateUserZone` mutation. */
export type UpdateUserZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID */
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `UserZone` being updated. */
  patch: UserZonePatch;
};

/** The output of our update `UserZone` mutation. */
export type UpdateUserZonePayload = {
  __typename?: 'UpdateUserZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserZone`. */
  user?: Maybe<User>;
  /** The `UserZone` that was updated by this mutation. */
  userZone?: Maybe<UserZone>;
  /** An edge for our `UserZone`. May be used by Relay 1. */
  userZoneEdge?: Maybe<UserZonesEdge>;
};


/** The output of our update `UserZone` mutation. */
export type UpdateUserZonePayloadUserZoneEdgeArgs = {
  orderBy?: InputMaybe<Array<UserZonesOrderBy>>;
};

/** All input for the upsert `UserDevice` mutation. */
export type UpsertUserDeviceInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserDevice` to be upserted by this mutation. */
  userDevice: UserDeviceInput;
};

/** The output of our upsert `UserDevice` mutation. */
export type UpsertUserDevicePayload = {
  __typename?: 'UpsertUserDevicePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserDevice`. */
  user?: Maybe<User>;
  /** The `UserDevice` that was upserted by this mutation. */
  userDevice?: Maybe<UserDevice>;
  /** An edge for our `UserDevice`. May be used by Relay 1. */
  userDeviceEdge?: Maybe<UserDevicesEdge>;
};


/** The output of our upsert `UserDevice` mutation. */
export type UpsertUserDevicePayloadUserDeviceEdgeArgs = {
  orderBy?: InputMaybe<Array<UserDevicesOrderBy>>;
};

/** Where conditions for the upsert `UserDevice` mutation. */
export type UpsertUserDeviceWhere = {
  id?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `UserService` mutation. */
export type UpsertUserServiceInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserService` to be upserted by this mutation. */
  userService: UserServiceInput;
};

/** The output of our upsert `UserService` mutation. */
export type UpsertUserServicePayload = {
  __typename?: 'UpsertUserServicePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `UserService` that is related to this `UserService`. */
  parent?: Maybe<UserService>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserService`. */
  user?: Maybe<User>;
  /** The `UserService` that was upserted by this mutation. */
  userService?: Maybe<UserService>;
  /** An edge for our `UserService`. May be used by Relay 1. */
  userServiceEdge?: Maybe<UserServicesEdge>;
};


/** The output of our upsert `UserService` mutation. */
export type UpsertUserServicePayloadUserServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<UserServicesOrderBy>>;
};

/** Where conditions for the upsert `UserService` mutation. */
export type UpsertUserServiceWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** A user */
export type User = Node & {
  __typename?: 'User';
  /** The timestamp when the user was created */
  createdAt: Scalars['Datetime'];
  /** The timestamp when the user was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `EmailAddress`. */
  emailAddresses: EmailAddressesConnection;
  /** The globally unique identifier for the user */
  guid: Scalars['UUID'];
  /** The primary unique identifier for the user */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The role of the user */
  role: Role;
  /** Reads and enables pagination through a set of `UserBooking`. */
  userBookings: UserBookingsConnection;
  /** Reads and enables pagination through a set of `UserCalendarEntry`. */
  userCalendarEntries: UserCalendarEntriesConnection;
  /** Reads and enables pagination through a set of `UserDevice`. */
  userDevices: UserDevicesConnection;
  /** Reads and enables pagination through a set of `UserRoutingHome`. */
  userRoutingHomes: UserRoutingHomesConnection;
  /** Reads and enables pagination through a set of `UserService`. */
  userServices: UserServicesConnection;
  /** Reads and enables pagination through a set of `UserZone`. */
  userZones: UserZonesConnection;
};


/** A user */
export type UserEmailAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmailAddressCondition>;
  filter?: InputMaybe<EmailAddressFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmailAddressesOrderBy>>;
};


/** A user */
export type UserUserBookingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserBookingCondition>;
  filter?: InputMaybe<UserBookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBookingsOrderBy>>;
};


/** A user */
export type UserUserCalendarEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCalendarEntryCondition>;
  filter?: InputMaybe<UserCalendarEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCalendarEntriesOrderBy>>;
};


/** A user */
export type UserUserDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDeviceCondition>;
  filter?: InputMaybe<UserDeviceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDevicesOrderBy>>;
};


/** A user */
export type UserUserRoutingHomesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserRoutingHomeCondition>;
  filter?: InputMaybe<UserRoutingHomeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRoutingHomesOrderBy>>;
};


/** A user */
export type UserUserServicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserServiceCondition>;
  filter?: InputMaybe<UserServiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserServicesOrderBy>>;
};


/** A user */
export type UserUserZonesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserZoneCondition>;
  filter?: InputMaybe<UserZoneFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserZonesOrderBy>>;
};

/** This table is used to store the user's routing home. */
export type UserBooking = Node & {
  __typename?: 'UserBooking';
  /** The date and time the record was created */
  createdAt: Scalars['Datetime'];
  /** The date and time the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** The date and time the user ended their booking */
  endingAt: Scalars['Datetime'];
  /** A unique identifier for the record */
  guid: Scalars['UUID'];
  /** Primary key */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The location of the user's routing home */
  point?: Maybe<GeometryPoint>;
  /** The date and time the user started their booking */
  startingAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserBooking`. */
  user?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserBookingPaymentState`. */
  userBookingPaymentStates: UserBookingPaymentStatesConnection;
  /** Reads and enables pagination through a set of `UserBookingState`. */
  userBookingStates: UserBookingStatesConnection;
  /** Reads and enables pagination through a set of `UserCalendarEntry`. */
  userCalendarEntries: UserCalendarEntriesConnection;
  /** Foreign key to the user table */
  userId: Scalars['Int'];
  /** Reads a single `UserZone` that is related to this `UserBooking`. */
  userZone?: Maybe<UserZone>;
  /** Foreign key to the user_zone table */
  userZoneId: Scalars['Int'];
};


/** This table is used to store the user's routing home. */
export type UserBookingUserBookingPaymentStatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserBookingPaymentStateCondition>;
  filter?: InputMaybe<UserBookingPaymentStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBookingPaymentStatesOrderBy>>;
};


/** This table is used to store the user's routing home. */
export type UserBookingUserBookingStatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserBookingStateCondition>;
  filter?: InputMaybe<UserBookingStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBookingStatesOrderBy>>;
};


/** This table is used to store the user's routing home. */
export type UserBookingUserCalendarEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCalendarEntryCondition>;
  filter?: InputMaybe<UserCalendarEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCalendarEntriesOrderBy>>;
};

/**
 * A condition to be used against `UserBooking` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserBookingCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endingAt` field. */
  endingAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `point` field. */
  point?: InputMaybe<Scalars['GeoJSON']>;
  /** Checks for equality with the object’s `startingAt` field. */
  startingAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userZoneId` field. */
  userZoneId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserBooking` object types. All fields are combined with a logical ‘and.’ */
export type UserBookingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserBookingFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endingAt` field. */
  endingAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserBookingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserBookingFilter>>;
  /** Filter by the object’s `startingAt` field. */
  startingAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userBookingPaymentStates` relation. */
  userBookingPaymentStates?: InputMaybe<UserBookingToManyUserBookingPaymentStateFilter>;
  /** Some related `userBookingPaymentStates` exist. */
  userBookingPaymentStatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userBookingStates` relation. */
  userBookingStates?: InputMaybe<UserBookingToManyUserBookingStateFilter>;
  /** Some related `userBookingStates` exist. */
  userBookingStatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCalendarEntries` relation. */
  userCalendarEntries?: InputMaybe<UserBookingToManyUserCalendarEntryFilter>;
  /** Some related `userCalendarEntries` exist. */
  userCalendarEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userZone` relation. */
  userZone?: InputMaybe<UserZoneFilter>;
  /** Filter by the object’s `userZoneId` field. */
  userZoneId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserBooking` */
export type UserBookingInput = {
  /** The date and time the user ended their booking */
  endingAt: Scalars['Datetime'];
  /** The location of the user's routing home */
  point?: InputMaybe<Scalars['GeoJSON']>;
  /** The date and time the user started their booking */
  startingAt: Scalars['Datetime'];
  /** Foreign key to the user table */
  userId: Scalars['Int'];
  /** Foreign key to the user_zone table */
  userZoneId: Scalars['Int'];
};

/** This table is used to store the user's booking payment state. */
export type UserBookingPaymentState = Node & {
  __typename?: 'UserBookingPaymentState';
  /** The date and time the record was created */
  createdAt: Scalars['Datetime'];
  /** The date and time the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** A unique identifier for the record */
  guid: Scalars['UUID'];
  /** Primary key */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The state of the booking payment */
  state: UserBookingPaymentStates;
  /** Reads a single `UserBooking` that is related to this `UserBookingPaymentState`. */
  userBooking?: Maybe<UserBooking>;
  /** Foreign key to the user_booking table */
  userBookingId: Scalars['Int'];
};

/**
 * A condition to be used against `UserBookingPaymentState` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UserBookingPaymentStateCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<UserBookingPaymentStates>;
  /** Checks for equality with the object’s `userBookingId` field. */
  userBookingId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserBookingPaymentState` object types. All fields are combined with a logical ‘and.’ */
export type UserBookingPaymentStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserBookingPaymentStateFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserBookingPaymentStateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserBookingPaymentStateFilter>>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<UserBookingPaymentStatesFilter>;
  /** Filter by the object’s `userBooking` relation. */
  userBooking?: InputMaybe<UserBookingFilter>;
  /** Filter by the object’s `userBookingId` field. */
  userBookingId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserBookingPaymentState` */
export type UserBookingPaymentStateInput = {
  /** The state of the booking payment */
  state: UserBookingPaymentStates;
  /** Foreign key to the user_booking table */
  userBookingId: Scalars['Int'];
};

export enum UserBookingPaymentStates {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

/** A connection to a list of `UserBookingPaymentState` values. */
export type UserBookingPaymentStatesConnection = {
  __typename?: 'UserBookingPaymentStatesConnection';
  /** A list of edges which contains the `UserBookingPaymentState` and cursor to aid in pagination. */
  edges: Array<UserBookingPaymentStatesEdge>;
  /** A list of `UserBookingPaymentState` objects. */
  nodes: Array<Maybe<UserBookingPaymentState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserBookingPaymentState` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserBookingPaymentState` edge in the connection. */
export type UserBookingPaymentStatesEdge = {
  __typename?: 'UserBookingPaymentStatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserBookingPaymentState` at the end of the edge. */
  node?: Maybe<UserBookingPaymentState>;
};

/** A filter to be used against UserBookingPaymentStates fields. All fields are combined with a logical ‘and.’ */
export type UserBookingPaymentStatesFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserBookingPaymentStates>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserBookingPaymentStates>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserBookingPaymentStates>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserBookingPaymentStates>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserBookingPaymentStates>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserBookingPaymentStates>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserBookingPaymentStates>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserBookingPaymentStates>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserBookingPaymentStates>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserBookingPaymentStates>>;
};

/** Methods to use when ordering `UserBookingPaymentState`. */
export enum UserBookingPaymentStatesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UserBookingIdAsc = 'USER_BOOKING_ID_ASC',
  UserBookingIdDesc = 'USER_BOOKING_ID_DESC'
}

/** This table is used to store the user's booking state. */
export type UserBookingState = Node & {
  __typename?: 'UserBookingState';
  /** The date and time the record was created */
  createdAt: Scalars['Datetime'];
  /** The date and time the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** A unique identifier for the record */
  guid: Scalars['UUID'];
  /** Primary key */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The state of the booking */
  state: UserBookingStates;
  /** Reads a single `UserBooking` that is related to this `UserBookingState`. */
  userBooking?: Maybe<UserBooking>;
  /** Foreign key to the user_booking table */
  userBookingId: Scalars['Int'];
};

/**
 * A condition to be used against `UserBookingState` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserBookingStateCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<UserBookingStates>;
  /** Checks for equality with the object’s `userBookingId` field. */
  userBookingId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserBookingState` object types. All fields are combined with a logical ‘and.’ */
export type UserBookingStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserBookingStateFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserBookingStateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserBookingStateFilter>>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<UserBookingStatesFilter>;
  /** Filter by the object’s `userBooking` relation. */
  userBooking?: InputMaybe<UserBookingFilter>;
  /** Filter by the object’s `userBookingId` field. */
  userBookingId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserBookingState` */
export type UserBookingStateInput = {
  /** The state of the booking */
  state: UserBookingStates;
  /** Foreign key to the user_booking table */
  userBookingId: Scalars['Int'];
};

export enum UserBookingStates {
  Aborted = 'ABORTED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Started = 'STARTED'
}

/** A connection to a list of `UserBookingState` values. */
export type UserBookingStatesConnection = {
  __typename?: 'UserBookingStatesConnection';
  /** A list of edges which contains the `UserBookingState` and cursor to aid in pagination. */
  edges: Array<UserBookingStatesEdge>;
  /** A list of `UserBookingState` objects. */
  nodes: Array<Maybe<UserBookingState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserBookingState` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserBookingState` edge in the connection. */
export type UserBookingStatesEdge = {
  __typename?: 'UserBookingStatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserBookingState` at the end of the edge. */
  node?: Maybe<UserBookingState>;
};

/** A filter to be used against UserBookingStates fields. All fields are combined with a logical ‘and.’ */
export type UserBookingStatesFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserBookingStates>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserBookingStates>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserBookingStates>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserBookingStates>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserBookingStates>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserBookingStates>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserBookingStates>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserBookingStates>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserBookingStates>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserBookingStates>>;
};

/** Methods to use when ordering `UserBookingState`. */
export enum UserBookingStatesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UserBookingIdAsc = 'USER_BOOKING_ID_ASC',
  UserBookingIdDesc = 'USER_BOOKING_ID_DESC'
}

/** A filter to be used against many `UserBookingPaymentState` object types. All fields are combined with a logical ‘and.’ */
export type UserBookingToManyUserBookingPaymentStateFilter = {
  /** Every related `UserBookingPaymentState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserBookingPaymentStateFilter>;
  /** No related `UserBookingPaymentState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserBookingPaymentStateFilter>;
  /** Some related `UserBookingPaymentState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserBookingPaymentStateFilter>;
};

/** A filter to be used against many `UserBookingState` object types. All fields are combined with a logical ‘and.’ */
export type UserBookingToManyUserBookingStateFilter = {
  /** Every related `UserBookingState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserBookingStateFilter>;
  /** No related `UserBookingState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserBookingStateFilter>;
  /** Some related `UserBookingState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserBookingStateFilter>;
};

/** A filter to be used against many `UserCalendarEntry` object types. All fields are combined with a logical ‘and.’ */
export type UserBookingToManyUserCalendarEntryFilter = {
  /** Every related `UserCalendarEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCalendarEntryFilter>;
  /** No related `UserCalendarEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCalendarEntryFilter>;
  /** Some related `UserCalendarEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCalendarEntryFilter>;
};

/** A connection to a list of `UserBooking` values. */
export type UserBookingsConnection = {
  __typename?: 'UserBookingsConnection';
  /** A list of edges which contains the `UserBooking` and cursor to aid in pagination. */
  edges: Array<UserBookingsEdge>;
  /** A list of `UserBooking` objects. */
  nodes: Array<Maybe<UserBooking>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserBooking` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserBooking` edge in the connection. */
export type UserBookingsEdge = {
  __typename?: 'UserBookingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserBooking` at the end of the edge. */
  node?: Maybe<UserBooking>;
};

/** Methods to use when ordering `UserBooking`. */
export enum UserBookingsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  EndingAtAsc = 'ENDING_AT_ASC',
  EndingAtDesc = 'ENDING_AT_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PointAsc = 'POINT_ASC',
  PointDesc = 'POINT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartingAtAsc = 'STARTING_AT_ASC',
  StartingAtDesc = 'STARTING_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  UserZoneIdAsc = 'USER_ZONE_ID_ASC',
  UserZoneIdDesc = 'USER_ZONE_ID_DESC'
}

/** A connection to a list of `UserCalendarEntry` values. */
export type UserCalendarEntriesConnection = {
  __typename?: 'UserCalendarEntriesConnection';
  /** A list of edges which contains the `UserCalendarEntry` and cursor to aid in pagination. */
  edges: Array<UserCalendarEntriesEdge>;
  /** A list of `UserCalendarEntry` objects. */
  nodes: Array<Maybe<UserCalendarEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserCalendarEntry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserCalendarEntry` edge in the connection. */
export type UserCalendarEntriesEdge = {
  __typename?: 'UserCalendarEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserCalendarEntry` at the end of the edge. */
  node?: Maybe<UserCalendarEntry>;
};

/** Methods to use when ordering `UserCalendarEntry`. */
export enum UserCalendarEntriesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  EndingAtAsc = 'ENDING_AT_ASC',
  EndingAtDesc = 'ENDING_AT_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RouteAsc = 'ROUTE_ASC',
  RouteDesc = 'ROUTE_DESC',
  StartingAtAsc = 'STARTING_AT_ASC',
  StartingAtDesc = 'STARTING_AT_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UserBookingIdAsc = 'USER_BOOKING_ID_ASC',
  UserBookingIdDesc = 'USER_BOOKING_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** This table is used to store the user's calendar. */
export type UserCalendarEntry = Node & {
  __typename?: 'UserCalendarEntry';
  /** The date and time the record was created */
  createdAt: Scalars['Datetime'];
  /** The date and time the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** The date and time the entry ended */
  endingAt: Scalars['Datetime'];
  /** A unique identifier for the record */
  guid: Scalars['UUID'];
  /** Primary key */
  id: Scalars['Int'];
  /** The date and time the entry was modified */
  modifiedAt?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The route of the calendar entry */
  route?: Maybe<Route>;
  /** The date and time the entry started */
  startingAt: Scalars['Datetime'];
  /** The type of calendar entry */
  type: UserCalendarEntryTypes;
  /** Reads a single `User` that is related to this `UserCalendarEntry`. */
  user?: Maybe<User>;
  /** Reads a single `UserBooking` that is related to this `UserCalendarEntry`. */
  userBooking?: Maybe<UserBooking>;
  /** Foreign key to the user_booking table */
  userBookingId: Scalars['Int'];
  /** Foreign key to the user table */
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `UserCalendarEntry` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserCalendarEntryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endingAt` field. */
  endingAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `route` field. */
  route?: InputMaybe<RouteInput>;
  /** Checks for equality with the object’s `startingAt` field. */
  startingAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<UserCalendarEntryTypes>;
  /** Checks for equality with the object’s `userBookingId` field. */
  userBookingId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserCalendarEntry` object types. All fields are combined with a logical ‘and.’ */
export type UserCalendarEntryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserCalendarEntryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endingAt` field. */
  endingAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserCalendarEntryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserCalendarEntryFilter>>;
  /** Filter by the object’s `route` field. */
  route?: InputMaybe<RouteFilter>;
  /** Filter by the object’s `startingAt` field. */
  startingAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<UserCalendarEntryTypesFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userBooking` relation. */
  userBooking?: InputMaybe<UserBookingFilter>;
  /** Filter by the object’s `userBookingId` field. */
  userBookingId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserCalendarEntry` */
export type UserCalendarEntryInput = {
  /** The date and time the entry ended */
  endingAt: Scalars['Datetime'];
  /** The date and time the entry was modified */
  modifiedAt?: InputMaybe<Scalars['Datetime']>;
  /** The route of the calendar entry */
  route?: InputMaybe<RouteInput>;
  /** The date and time the entry started */
  startingAt: Scalars['Datetime'];
  /** The type of calendar entry */
  type: UserCalendarEntryTypes;
  /** Foreign key to the user_booking table */
  userBookingId: Scalars['Int'];
  /** Foreign key to the user table */
  userId: Scalars['Int'];
};

export enum UserCalendarEntryTypes {
  Booking = 'BOOKING',
  Commute = 'COMMUTE'
}

/** A filter to be used against UserCalendarEntryTypes fields. All fields are combined with a logical ‘and.’ */
export type UserCalendarEntryTypesFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserCalendarEntryTypes>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserCalendarEntryTypes>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserCalendarEntryTypes>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserCalendarEntryTypes>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserCalendarEntryTypes>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserCalendarEntryTypes>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserCalendarEntryTypes>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserCalendarEntryTypes>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserCalendarEntryTypes>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserCalendarEntryTypes>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<Role>;
};

/** A users email address */
export type UserDevice = Node & {
  __typename?: 'UserDevice';
  /** The timestamp when the user email address was created */
  createdAt: Scalars['Datetime'];
  /** The timestamp when the user email address was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** The globally unique identifier for the users email address */
  guid: Scalars['UUID'];
  /** The primary unique identifier for the users email address */
  id: Scalars['String'];
  /** The device info. */
  info: Scalars['JSON'];
  /** The modified_at of the user_device */
  modifiedAt?: Maybe<Scalars['Datetime']>;
  /** The modified_count of the user_device */
  modifiedCount: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  subscription?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `Subscription`. */
  subscriptions: SubscriptionsConnection;
  /** Reads a single `User` that is related to this `UserDevice`. */
  user?: Maybe<User>;
  /** The user id of the user */
  userId: Scalars['Int'];
};


/** A users email address */
export type UserDeviceSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SubscriptionCondition>;
  filter?: InputMaybe<SubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionsOrderBy>>;
};

/**
 * A condition to be used against `UserDevice` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserDeviceCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `info` field. */
  info?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `subscription` field. */
  subscription?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserDevice` object types. All fields are combined with a logical ‘and.’ */
export type UserDeviceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserDeviceFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `info` field. */
  info?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserDeviceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserDeviceFilter>>;
  /** Filter by the object’s `subscription` field. */
  subscription?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `subscriptions` relation. */
  subscriptions?: InputMaybe<UserDeviceToManySubscriptionFilter>;
  /** Some related `subscriptions` exist. */
  subscriptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserDevice` */
export type UserDeviceInput = {
  /** The timestamp when the user email address was deleted */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** The primary unique identifier for the users email address */
  id: Scalars['String'];
  /** The device info. */
  info: Scalars['JSON'];
  subscription?: InputMaybe<Scalars['JSON']>;
  /** The user id of the user */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against many `Subscription` object types. All fields are combined with a logical ‘and.’ */
export type UserDeviceToManySubscriptionFilter = {
  /** Every related `Subscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SubscriptionFilter>;
  /** No related `Subscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SubscriptionFilter>;
  /** Some related `Subscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SubscriptionFilter>;
};

/** A connection to a list of `UserDevice` values. */
export type UserDevicesConnection = {
  __typename?: 'UserDevicesConnection';
  /** A list of edges which contains the `UserDevice` and cursor to aid in pagination. */
  edges: Array<UserDevicesEdge>;
  /** A list of `UserDevice` objects. */
  nodes: Array<Maybe<UserDevice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserDevice` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserDevice` edge in the connection. */
export type UserDevicesEdge = {
  __typename?: 'UserDevicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserDevice` at the end of the edge. */
  node?: Maybe<UserDevice>;
};

/** Methods to use when ordering `UserDevice`. */
export enum UserDevicesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InfoAsc = 'INFO_ASC',
  InfoDesc = 'INFO_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  ModifiedCountAsc = 'MODIFIED_COUNT_ASC',
  ModifiedCountDesc = 'MODIFIED_COUNT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SubscriptionAsc = 'SUBSCRIPTION_ASC',
  SubscriptionDesc = 'SUBSCRIPTION_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `emailAddresses` relation. */
  emailAddresses?: InputMaybe<UserToManyEmailAddressFilter>;
  /** Some related `emailAddresses` exist. */
  emailAddressesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<RoleFilter>;
  /** Filter by the object’s `userBookings` relation. */
  userBookings?: InputMaybe<UserToManyUserBookingFilter>;
  /** Some related `userBookings` exist. */
  userBookingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCalendarEntries` relation. */
  userCalendarEntries?: InputMaybe<UserToManyUserCalendarEntryFilter>;
  /** Some related `userCalendarEntries` exist. */
  userCalendarEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userDevices` relation. */
  userDevices?: InputMaybe<UserToManyUserDeviceFilter>;
  /** Some related `userDevices` exist. */
  userDevicesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userRoutingHomes` relation. */
  userRoutingHomes?: InputMaybe<UserToManyUserRoutingHomeFilter>;
  /** Some related `userRoutingHomes` exist. */
  userRoutingHomesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userServices` relation. */
  userServices?: InputMaybe<UserToManyUserServiceFilter>;
  /** Some related `userServices` exist. */
  userServicesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userZones` relation. */
  userZones?: InputMaybe<UserToManyUserZoneFilter>;
  /** Some related `userZones` exist. */
  userZonesExist?: InputMaybe<Scalars['Boolean']>;
};

/** This table is used to store the user's routing home. */
export type UserRoutingHome = Node & {
  __typename?: 'UserRoutingHome';
  /** The date and time the record was created */
  createdAt: Scalars['Datetime'];
  /** The data for the user's routing home */
  data: Scalars['JSON'];
  /** The date and time the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** A unique identifier for the record */
  guid: Scalars['UUID'];
  /** Primary key */
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The location of the user's routing home */
  point?: Maybe<GeometryPoint>;
  /** Reads a single `User` that is related to this `UserRoutingHome`. */
  user?: Maybe<User>;
  /** Foreign key to the user table */
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `UserRoutingHome` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserRoutingHomeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `point` field. */
  point?: InputMaybe<Scalars['GeoJSON']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserRoutingHome` object types. All fields are combined with a logical ‘and.’ */
export type UserRoutingHomeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRoutingHomeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserRoutingHomeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRoutingHomeFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserRoutingHome` */
export type UserRoutingHomeInput = {
  /** The data for the user's routing home */
  data: Scalars['JSON'];
  /** The location of the user's routing home */
  point?: InputMaybe<Scalars['GeoJSON']>;
  /** Foreign key to the user table */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `UserRoutingHome` values. */
export type UserRoutingHomesConnection = {
  __typename?: 'UserRoutingHomesConnection';
  /** A list of edges which contains the `UserRoutingHome` and cursor to aid in pagination. */
  edges: Array<UserRoutingHomesEdge>;
  /** A list of `UserRoutingHome` objects. */
  nodes: Array<Maybe<UserRoutingHome>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRoutingHome` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserRoutingHome` edge in the connection. */
export type UserRoutingHomesEdge = {
  __typename?: 'UserRoutingHomesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserRoutingHome` at the end of the edge. */
  node?: Maybe<UserRoutingHome>;
};

/** Methods to use when ordering `UserRoutingHome`. */
export enum UserRoutingHomesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DataAsc = 'DATA_ASC',
  DataDesc = 'DATA_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PointAsc = 'POINT_ASC',
  PointDesc = 'POINT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** User Services & Categories */
export type UserService = Node & {
  __typename?: 'UserService';
  /** Reads and enables pagination through a set of `UserService`. */
  childUserServices: UserServicesConnection;
  /** Created At */
  createdAt: Scalars['Datetime'];
  /** Data */
  data: Scalars['JSON'];
  /** Deleted At */
  deletedAt?: Maybe<Scalars['Datetime']>;
  description: Scalars['String'];
  duration: Interval;
  /** GUID */
  guid: Scalars['UUID'];
  /** Primary Key */
  id: Scalars['Int'];
  /** Index */
  index: Scalars['Int'];
  /** Modified At */
  modifiedAt: Scalars['Datetime'];
  /** Modified Count */
  modifiedCount: Scalars['Int'];
  /** Name */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `UserService` that is related to this `UserService`. */
  parent?: Maybe<UserService>;
  /** Parent Service */
  parentId?: Maybe<Scalars['Int']>;
  price: Price;
  type: UserServiceType;
  /** Reads a single `User` that is related to this `UserService`. */
  user?: Maybe<User>;
  /** User ID */
  userId: Scalars['Int'];
};


/** User Services & Categories */
export type UserServiceChildUserServicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserServiceCondition>;
  filter?: InputMaybe<UserServiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserServicesOrderBy>>;
};

/**
 * A condition to be used against `UserService` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserServiceCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<PriceInput>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<UserServiceType>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserService` object types. All fields are combined with a logical ‘and.’ */
export type UserServiceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserServiceFilter>>;
  /** Filter by the object’s `childUserServices` relation. */
  childUserServices?: InputMaybe<UserServiceToManyUserServiceFilter>;
  /** Some related `childUserServices` exist. */
  childUserServicesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `data` field. */
  data?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserServiceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserServiceFilter>>;
  /** Filter by the object’s `parent` relation. */
  parent?: InputMaybe<UserServiceFilter>;
  /** A related `parent` exists. */
  parentExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<PriceFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<UserServiceTypeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserService` */
export type UserServiceInput = {
  /** Data */
  data?: InputMaybe<Scalars['JSON']>;
  description: Scalars['String'];
  duration: IntervalInput;
  /** Name */
  name: Scalars['String'];
  /** Parent Service */
  parentId?: InputMaybe<Scalars['Int']>;
  price: PriceInput;
  type: UserServiceType;
};

/** Represents an update to a `UserService`. Fields that are set will be updated. */
export type UserServicePatch = {
  /** Data */
  data?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<IntervalInput>;
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  /** Parent Service */
  parentId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<PriceInput>;
  type?: InputMaybe<UserServiceType>;
};

/** A filter to be used against many `UserService` object types. All fields are combined with a logical ‘and.’ */
export type UserServiceToManyUserServiceFilter = {
  /** Every related `UserService` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserServiceFilter>;
  /** No related `UserService` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserServiceFilter>;
  /** Some related `UserService` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserServiceFilter>;
};

export enum UserServiceType {
  Category = 'CATEGORY',
  Service = 'SERVICE'
}

/** A filter to be used against UserServiceType fields. All fields are combined with a logical ‘and.’ */
export type UserServiceTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserServiceType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserServiceType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserServiceType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserServiceType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserServiceType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserServiceType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserServiceType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserServiceType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserServiceType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserServiceType>>;
};

export type UserServiceView = {
  __typename?: 'UserServiceView';
  createdAt?: Maybe<Scalars['Datetime']>;
  data?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Interval>;
  guid?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['Int']>;
  index?: Maybe<Scalars['Int']>;
  modifiedAt?: Maybe<Scalars['Datetime']>;
  modifiedCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['Int']>;
  price?: Maybe<Price>;
  type?: Maybe<UserServiceType>;
  userId?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `UserServiceView` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserServiceViewCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<PriceInput>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<UserServiceType>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserServiceView` object types. All fields are combined with a logical ‘and.’ */
export type UserServiceViewFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserServiceViewFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `data` field. */
  data?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserServiceViewFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserServiceViewFilter>>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<PriceFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<UserServiceTypeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserServiceView` */
export type UserServiceViewInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  data?: InputMaybe<Scalars['JSON']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<IntervalInput>;
  guid?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['Int']>;
  index?: InputMaybe<Scalars['Int']>;
  modifiedAt?: InputMaybe<Scalars['Datetime']>;
  modifiedCount?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<PriceInput>;
  type?: InputMaybe<UserServiceType>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `UserServiceView` values. */
export type UserServiceViewsConnection = {
  __typename?: 'UserServiceViewsConnection';
  /** A list of edges which contains the `UserServiceView` and cursor to aid in pagination. */
  edges: Array<UserServiceViewsEdge>;
  /** A list of `UserServiceView` objects. */
  nodes: Array<Maybe<UserServiceView>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserServiceView` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserServiceView` edge in the connection. */
export type UserServiceViewsEdge = {
  __typename?: 'UserServiceViewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserServiceView` at the end of the edge. */
  node?: Maybe<UserServiceView>;
};

/** Methods to use when ordering `UserServiceView`. */
export enum UserServiceViewsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DataAsc = 'DATA_ASC',
  DataDesc = 'DATA_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  ModifiedCountAsc = 'MODIFIED_COUNT_ASC',
  ModifiedCountDesc = 'MODIFIED_COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  ParentIdAsc = 'PARENT_ID_ASC',
  ParentIdDesc = 'PARENT_ID_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A connection to a list of `UserService` values. */
export type UserServicesConnection = {
  __typename?: 'UserServicesConnection';
  /** A list of edges which contains the `UserService` and cursor to aid in pagination. */
  edges: Array<UserServicesEdge>;
  /** A list of `UserService` objects. */
  nodes: Array<Maybe<UserService>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserService` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserService` edge in the connection. */
export type UserServicesEdge = {
  __typename?: 'UserServicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserService` at the end of the edge. */
  node?: Maybe<UserService>;
};

/** Methods to use when ordering `UserService`. */
export enum UserServicesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DataAsc = 'DATA_ASC',
  DataDesc = 'DATA_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  ModifiedCountAsc = 'MODIFIED_COUNT_ASC',
  ModifiedCountDesc = 'MODIFIED_COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  ParentIdAsc = 'PARENT_ID_ASC',
  ParentIdDesc = 'PARENT_ID_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A filter to be used against many `EmailAddress` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyEmailAddressFilter = {
  /** Every related `EmailAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmailAddressFilter>;
  /** No related `EmailAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmailAddressFilter>;
  /** Some related `EmailAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmailAddressFilter>;
};

/** A filter to be used against many `UserBooking` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserBookingFilter = {
  /** Every related `UserBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserBookingFilter>;
  /** No related `UserBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserBookingFilter>;
  /** Some related `UserBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserBookingFilter>;
};

/** A filter to be used against many `UserCalendarEntry` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserCalendarEntryFilter = {
  /** Every related `UserCalendarEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCalendarEntryFilter>;
  /** No related `UserCalendarEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCalendarEntryFilter>;
  /** Some related `UserCalendarEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCalendarEntryFilter>;
};

/** A filter to be used against many `UserDevice` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserDeviceFilter = {
  /** Every related `UserDevice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDeviceFilter>;
  /** No related `UserDevice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDeviceFilter>;
  /** Some related `UserDevice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDeviceFilter>;
};

/** A filter to be used against many `UserRoutingHome` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserRoutingHomeFilter = {
  /** Every related `UserRoutingHome` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRoutingHomeFilter>;
  /** No related `UserRoutingHome` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRoutingHomeFilter>;
  /** Some related `UserRoutingHome` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRoutingHomeFilter>;
};

/** A filter to be used against many `UserService` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserServiceFilter = {
  /** Every related `UserService` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserServiceFilter>;
  /** No related `UserService` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserServiceFilter>;
  /** Some related `UserService` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserServiceFilter>;
};

/** A filter to be used against many `UserZone` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserZoneFilter = {
  /** Every related `UserZone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserZoneFilter>;
  /** No related `UserZone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserZoneFilter>;
  /** Some related `UserZone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserZoneFilter>;
};

/** Zone */
export type UserZone = Node & {
  __typename?: 'UserZone';
  /** Color */
  color: Scalars['String'];
  /** Created At */
  createdAt: Scalars['Datetime'];
  /** Data */
  data: Scalars['JSON'];
  /** Deleted At */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `UserZoneGeometry`. */
  geometry: UserZoneGeometriesConnection;
  /** GUID */
  guid: Scalars['UUID'];
  /** ID */
  id: Scalars['Int'];
  kilometerPrice: Price;
  /** Modified At */
  modifiedAt: Scalars['Datetime'];
  /** Modified Count */
  modifiedCount: Scalars['Int'];
  /** Name */
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Rules */
  rules: Timesandrule;
  /** Reads a single `User` that is related to this `UserZone`. */
  user?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserBooking`. */
  userBookings: UserBookingsConnection;
  /** User */
  userId: Scalars['Int'];
};


/** Zone */
export type UserZoneGeometryArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserZoneGeometryCondition>;
  filter?: InputMaybe<UserZoneGeometryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserZoneGeometriesOrderBy>>;
};


/** Zone */
export type UserZoneUserBookingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserBookingCondition>;
  filter?: InputMaybe<UserBookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBookingsOrderBy>>;
};

/**
 * A condition to be used against `UserZone` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserZoneCondition = {
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `guid` field. */
  guid?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `kilometerPrice` field. */
  kilometerPrice?: InputMaybe<PriceInput>;
  /** Checks for equality with the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `rules` field. */
  rules?: InputMaybe<TimesandruleInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserZone` object types. All fields are combined with a logical ‘and.’ */
export type UserZoneFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserZoneFilter>>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `data` field. */
  data?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `geometry` relation. */
  geometry?: InputMaybe<UserZoneToManyUserZoneGeometryFilter>;
  /** Some related `geometry` exist. */
  geometryExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `guid` field. */
  guid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `kilometerPrice` field. */
  kilometerPrice?: InputMaybe<PriceFilter>;
  /** Filter by the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserZoneFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserZoneFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userBookings` relation. */
  userBookings?: InputMaybe<UserZoneToManyUserBookingFilter>;
  /** Some related `userBookings` exist. */
  userBookingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `UserZoneGeometry` values. */
export type UserZoneGeometriesConnection = {
  __typename?: 'UserZoneGeometriesConnection';
  /** A list of edges which contains the `UserZoneGeometry` and cursor to aid in pagination. */
  edges: Array<UserZoneGeometriesEdge>;
  /** A list of `UserZoneGeometry` objects. */
  nodes: Array<Maybe<UserZoneGeometry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserZoneGeometry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserZoneGeometry` edge in the connection. */
export type UserZoneGeometriesEdge = {
  __typename?: 'UserZoneGeometriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserZoneGeometry` at the end of the edge. */
  node?: Maybe<UserZoneGeometry>;
};

/** Methods to use when ordering `UserZoneGeometry`. */
export enum UserZoneGeometriesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  ModifiedCountAsc = 'MODIFIED_COUNT_ASC',
  ModifiedCountDesc = 'MODIFIED_COUNT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserZoneIdAsc = 'USER_ZONE_ID_ASC',
  UserZoneIdDesc = 'USER_ZONE_ID_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Zone Geometry */
export type UserZoneGeometry = Node & {
  __typename?: 'UserZoneGeometry';
  /** Created At */
  createdAt: Scalars['Datetime'];
  /** Deleted At */
  deletedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  /** Modified At */
  modifiedAt: Scalars['Datetime'];
  /** Modified Count */
  modifiedCount: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `UserZone` that is related to this `UserZoneGeometry`. */
  userZone?: Maybe<UserZone>;
  /** Zone */
  userZoneId: Scalars['Int'];
  /** Geometry */
  value: GeometryInterface;
};

/**
 * A condition to be used against `UserZoneGeometry` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserZoneGeometryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userZoneId` field. */
  userZoneId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['GeoJSON']>;
};

/** A filter to be used against `UserZoneGeometry` object types. All fields are combined with a logical ‘and.’ */
export type UserZoneGeometryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserZoneGeometryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedAt` field. */
  modifiedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `modifiedCount` field. */
  modifiedCount?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserZoneGeometryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserZoneGeometryFilter>>;
  /** Filter by the object’s `userZone` relation. */
  userZone?: InputMaybe<UserZoneFilter>;
  /** Filter by the object’s `userZoneId` field. */
  userZoneId?: InputMaybe<IntFilter>;
};

export type UserZoneGeometryResult = {
  __typename?: 'UserZoneGeometryResult';
  id?: Maybe<Scalars['Int']>;
  newValue?: Maybe<GeometryInterface>;
  type?: Maybe<CrudType>;
  zoneId?: Maybe<Scalars['Int']>;
};

/** An input for mutations affecting `UserZone` */
export type UserZoneInput = {
  /** Color */
  color: Scalars['String'];
  /** Data */
  data?: InputMaybe<Scalars['JSON']>;
  kilometerPrice: PriceInput;
  /** Name */
  name: Scalars['String'];
  /** Rules */
  rules: TimesandruleInput;
};

/** Represents an update to a `UserZone`. Fields that are set will be updated. */
export type UserZonePatch = {
  /** Color */
  color?: InputMaybe<Scalars['String']>;
  /** Data */
  data?: InputMaybe<Scalars['JSON']>;
  kilometerPrice?: InputMaybe<PriceInput>;
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  /** Rules */
  rules?: InputMaybe<TimesandruleInput>;
};

/** A filter to be used against many `UserBooking` object types. All fields are combined with a logical ‘and.’ */
export type UserZoneToManyUserBookingFilter = {
  /** Every related `UserBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserBookingFilter>;
  /** No related `UserBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserBookingFilter>;
  /** Some related `UserBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserBookingFilter>;
};

/** A filter to be used against many `UserZoneGeometry` object types. All fields are combined with a logical ‘and.’ */
export type UserZoneToManyUserZoneGeometryFilter = {
  /** Every related `UserZoneGeometry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserZoneGeometryFilter>;
  /** No related `UserZoneGeometry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserZoneGeometryFilter>;
  /** Some related `UserZoneGeometry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserZoneGeometryFilter>;
};

/** A connection to a list of `UserZone` values. */
export type UserZonesConnection = {
  __typename?: 'UserZonesConnection';
  /** A list of edges which contains the `UserZone` and cursor to aid in pagination. */
  edges: Array<UserZonesEdge>;
  /** A list of `UserZone` objects. */
  nodes: Array<Maybe<UserZone>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserZone` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserZone` edge in the connection. */
export type UserZonesEdge = {
  __typename?: 'UserZonesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserZone` at the end of the edge. */
  node?: Maybe<UserZone>;
};

/** Methods to use when ordering `UserZone`. */
export enum UserZonesOrderBy {
  ColorAsc = 'COLOR_ASC',
  ColorDesc = 'COLOR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DataAsc = 'DATA_ASC',
  DataDesc = 'DATA_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KilometerPriceAsc = 'KILOMETER_PRICE_ASC',
  KilometerPriceDesc = 'KILOMETER_PRICE_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  ModifiedCountAsc = 'MODIFIED_COUNT_ASC',
  ModifiedCountDesc = 'MODIFIED_COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RulesAsc = 'RULES_ASC',
  RulesDesc = 'RULES_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  GuidAsc = 'GUID_ASC',
  GuidDesc = 'GUID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC'
}

export type AuthMutationVariables = Exact<{
  input: AuthInput;
}>;


export type AuthMutation = { __typename?: 'Mutation', auth?: { __typename?: 'AuthPayload', result?: { __typename?: 'AuthResult', expiresAt?: any | null, success?: boolean | null, token?: any | null } | null } | null };

export type CreateMagicLinkMutationVariables = Exact<{
  input: CreateMagicLinkInput;
}>;


export type CreateMagicLinkMutation = { __typename?: 'Mutation', createMagicLink?: { __typename?: 'CreateMagicLinkResult', success: boolean, guid?: string | null, errors?: Array<{ __typename?: 'Error', message: string, code: string } | null> | null } | null };

export type CreateBookingMutationVariables = Exact<{
  input?: InputMaybe<CreateBookingInput>;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking?: { __typename?: 'CreateBookingResponse', success: boolean, userBooking?: { __typename?: 'UserBooking', id: number } | null } | null };

export type GetPossibleAppointmentsQueryVariables = Exact<{
  input: GetPossibleAppointmentsInput;
}>;


export type GetPossibleAppointmentsQuery = { __typename?: 'Query', getPossibleAppointments?: { __typename?: 'PossibleAppointmentResponse', count: number, result?: Array<{ __typename?: 'PossibleAppointment', cost?: number | null, serviceEnd?: string | null, serviceStart?: string | null, totalDuration?: number | null, service?: { __typename?: 'Service', cost?: number | null, duration?: number | null } | null, commute?: { __typename?: 'Commute', totalCost?: number | null, totalDistance?: number | null, totalDuration?: number | null, bufferTime?: number | null, to?: { __typename?: 'CommutePart', costCurrency?: string | null, distance?: number | null, totalCost?: number | null, end?: string | null, start?: string | null, cost?: { __typename?: 'Cost', distance?: number | null, time?: number | null } | null } | null, from?: { __typename?: 'CommutePart', costCurrency?: string | null, distance?: number | null, totalCost?: number | null, end?: string | null, start?: string | null, cost?: { __typename?: 'Cost', distance?: number | null, time?: number | null } | null } | null } | null } | null> | null } | null };

export type AllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCountriesQuery = { __typename?: 'Query', countries?: { __typename?: 'CountriesConnection', nodes: Array<{ __typename?: 'Country', id: number, iso2?: string | null, name?: string | null, translations?: any | null } | null> } | null };

export type GeocodeMutationVariables = Exact<{
  input: GeocodeInput;
}>;


export type GeocodeMutation = { __typename?: 'Mutation', geocode?: Array<{ __typename?: 'GeocodeResponse', latitude?: number | null, longitude?: number | null, state?: string | null, streetName?: string | null, streetNumber?: string | null, zipcode?: string | null, city?: string | null, country?: string | null } | null> | null };

export type ReverseGeocodeMutationVariables = Exact<{
  input: ReverseGeocodeInput;
}>;


export type ReverseGeocodeMutation = { __typename?: 'Mutation', reverseGeocode?: Array<{ __typename?: 'GeocodeResponse', city?: string | null, country?: string | null, countryCode?: string | null, latitude?: number | null, longitude?: number | null, provider?: string | null, state?: string | null, streetName?: string | null, streetNumber?: string | null, zipcode?: string | null, stateCode?: string | null, formattedAddress?: string | null, district?: string | null, county?: string | null, building?: string | null, extra?: { __typename?: 'GeocodeResponseExtra', confidence?: number | null, googlePlaceId?: string | null } | null, administrativeLevels?: { __typename?: 'GeocodeResponseAdministrativeLevels', level1long?: string | null, level1short?: string | null, level2long?: string | null, level2short?: string | null } | null } | null> | null };

export type MeRequestQueryVariables = Exact<{ [key: string]: never; }>;


export type MeRequestQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: number, role: Role, emailAddresses: { __typename?: 'EmailAddressesConnection', nodes: Array<{ __typename?: 'EmailAddress', value: any } | null> }, userDevices: { __typename?: 'UserDevicesConnection', nodes: Array<{ __typename?: 'UserDevice', id: string, info: any, deletedAt?: any | null, modifiedAt?: any | null, subscriptions: { __typename?: 'SubscriptionsConnection', nodes: Array<{ __typename?: 'Subscription', id: number, topic: Topic, userDeviceId: string } | null> } } | null> }, userRoutingHomes: { __typename?: 'UserRoutingHomesConnection', nodes: Array<{ __typename?: 'UserRoutingHome', data: any, point?: { __typename?: 'GeometryPoint', x: number, y: number } | null } | null> } } | null, serverTime?: { __typename?: 'ServerTimeResponse', value: any } | null };

export type NotifyUserMutationVariables = Exact<{
  input: NotifyUserInput;
}>;


export type NotifyUserMutation = { __typename?: 'Mutation', notifyUser?: { __typename?: 'NotifyUserResponse', success: boolean } | null };

export type SubscribToNewsletterMutationVariables = Exact<{
  input: NewsletterSubscribeRequest;
}>;


export type SubscribToNewsletterMutation = { __typename?: 'Mutation', subscribeToNewsletter?: { __typename?: 'NewsletterSubscribeResult', success: boolean, errors: Array<string> } | null };

export type SubscribeMutationVariables = Exact<{
  input: SubscribeInput;
}>;


export type SubscribeMutation = { __typename?: 'Mutation', subscribe?: { __typename?: 'SubscribePayload', simpleResult?: { __typename?: 'SimpleResult', success?: boolean | null } | null } | null };

export type UnsubscribeMutationVariables = Exact<{
  input: UnsubscribeInput;
}>;


export type UnsubscribeMutation = { __typename?: 'Mutation', unsubscribe?: { __typename?: 'UnsubscribePayload', simpleResult?: { __typename?: 'SimpleResult', success?: boolean | null } | null } | null };

export type AllTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTopicsQuery = { __typename?: 'Query', allTopics?: { __typename?: 'AllTopicsConnection', nodes: Array<{ __typename?: 'AllTopic', id?: string | null } | null> } | null };

export type AllUserCalendarEntriesQueryVariables = Exact<{
  filter?: InputMaybe<UserCalendarEntryFilter>;
}>;


export type AllUserCalendarEntriesQuery = { __typename?: 'Query', userCalendarEntries?: { __typename?: 'UserCalendarEntriesConnection', nodes: Array<{ __typename?: 'UserCalendarEntry', id: number, type: UserCalendarEntryTypes, startingAt: any, endingAt: any, deletedAt?: any | null, route?: { __typename?: 'Route', bbox?: Array<number | null> | null, geometry?: string | null, wayPoints?: Array<number | null> | null, segments?: Array<{ __typename?: 'RouteSegment', distance?: number | null, duration?: number | null, steps?: Array<{ __typename?: 'RouteStep', distance?: number | null, duration?: number | null, instruction?: string | null, name?: string | null, type?: number | null, wayPoints?: Array<number | null> | null } | null> | null } | null> | null, summary?: { __typename?: 'RouteSummary', distance?: number | null, duration?: number | null } | null } | null, userBooking?: { __typename?: 'UserBooking', endingAt: any, startingAt: any, id: number, guid: any, createdAt: any, userId: number, userZone?: { __typename?: 'UserZone', id: number, color: string, name: string } | null, point?: { __typename?: 'GeometryPoint', x: number, y: number, geojson?: any | null, srid: number } | null } | null } | null> } | null };

export type DeleteUserDeviceMutationVariables = Exact<{
  input: DeleteUserDeviceInput;
}>;


export type DeleteUserDeviceMutation = { __typename?: 'Mutation', deleteUserDevice?: { __typename?: 'DeleteUserDevicePayload', simpleResult?: { __typename?: 'SimpleResult', success?: boolean | null } | null } | null };

export type UpsertUserDeviceMutationVariables = Exact<{
  input: UpsertUserDeviceInput;
  id: Scalars['String'];
}>;


export type UpsertUserDeviceMutation = { __typename?: 'Mutation', upsertUserDevice?: { __typename?: 'UpsertUserDevicePayload', userDevice?: { __typename?: 'UserDevice', id: string, info: any, subscription?: any | null } | null } | null };

export type UserDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDevicesQuery = { __typename?: 'Query', userDevices?: { __typename?: 'UserDevicesConnection', nodes: Array<{ __typename?: 'UserDevice', id: string, info: any, subscription?: any | null, createdAt: any, modifiedAt?: any | null } | null> } | null };

export type CreateUserRoutingHomeMutationVariables = Exact<{
  input: CreateUserRoutingHomeInput;
}>;


export type CreateUserRoutingHomeMutation = { __typename?: 'Mutation', createUserRoutingHome?: { __typename?: 'CreateUserRoutingHomePayload', userRoutingHomeEdge?: { __typename?: 'UserRoutingHomesEdge', node?: { __typename?: 'UserRoutingHome', id: number, data: any, point?: { __typename?: 'GeometryPoint', geojson?: any | null, srid: number, x: number, y: number } | null } | null } | null } | null };

export type CreateUserServiceMutationVariables = Exact<{
  input: CreateUserServiceInput;
}>;


export type CreateUserServiceMutation = { __typename?: 'Mutation', createUserService?: { __typename?: 'CreateUserServicePayload', userService?: { __typename?: 'UserService', id: number, guid: any, data: any, createdAt: any, parentId?: number | null, type: UserServiceType, name: string, index: number, description: string, duration: { __typename?: 'Interval', hours?: number | null, minutes?: number | null }, price: { __typename?: 'Price', amount?: any | null, currency?: string | null } } | null } | null };

export type DeleteUserServiceMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type DeleteUserServiceMutation = { __typename?: 'Mutation', deleteUserService?: { __typename?: 'DeleteUserServicePayload', simpleResult?: { __typename?: 'SimpleResult', success?: boolean | null } | null } | null };

export type UpdateUserServiceMutationVariables = Exact<{
  id: Scalars['Int'];
  patch: UserServicePatch;
}>;


export type UpdateUserServiceMutation = { __typename?: 'Mutation', updateUserService?: { __typename?: 'UpdateUserServicePayload', userService?: { __typename?: 'UserService', type: UserServiceType, parentId?: number | null, name: string, index: number, id: number, guid: any, data: any, createdAt: any, description: string, duration: { __typename?: 'Interval', hours?: number | null, minutes?: number | null }, price: { __typename?: 'Price', amount?: any | null, currency?: string | null } } | null } | null };

export type UpdateUserServiceIndexMutationVariables = Exact<{
  input: UpdateUserServiceIndexInput;
}>;


export type UpdateUserServiceIndexMutation = { __typename?: 'Mutation', updateUserServiceIndex?: { __typename?: 'UpdateUserServiceIndexPayload', simpleResult?: { __typename?: 'SimpleResult', success?: boolean | null } | null } | null };

export type UserServiceQueryVariables = Exact<{ [key: string]: never; }>;


export type UserServiceQuery = { __typename?: 'Query', userServiceViews?: { __typename?: 'UserServiceViewsConnection', nodes: Array<{ __typename?: 'UserServiceView', type?: UserServiceType | null, parentId?: number | null, name?: string | null, index?: number | null, id?: number | null, guid?: any | null, data?: any | null, createdAt?: any | null, description?: string | null, duration?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null } | null, price?: { __typename?: 'Price', amount?: any | null, currency?: string | null } | null } | null> } | null };

export type CreateUserZoneMutationVariables = Exact<{
  input: CreateUserZoneInput;
}>;


export type CreateUserZoneMutation = { __typename?: 'Mutation', createUserZone?: { __typename?: 'CreateUserZonePayload', userZone?: { __typename?: 'UserZone', id: number, name: string, color: string, kilometerPrice: { __typename?: 'Price', amount?: any | null, currency?: string | null }, rules: { __typename?: 'Timesandrule', exrules?: Array<{ __typename?: 'Rruleeditorxvalue', rule?: string | null, holiday?: { __typename?: 'Holidayvalue', days?: Array<number | null> | null, holidays?: Array<{ __typename?: 'Holiday', country?: string | null, id?: number | null, name?: string | null } | null> | null } | null } | null> | null, rules?: Array<{ __typename?: 'Rruleeditorxvalue', rule?: string | null, holiday?: { __typename?: 'Holidayvalue', days?: Array<number | null> | null, holidays?: Array<{ __typename?: 'Holiday', id?: number | null, country?: string | null, name?: string | null } | null> | null } | null } | null> | null, times?: Array<{ __typename?: 'Timespan', end?: any | null, start?: any | null } | null> | null } } | null } | null };

export type DeleteUserZoneMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteUserZoneMutation = { __typename?: 'Mutation', deleteUserZone?: { __typename?: 'DeleteUserZonePayload', simpleResult?: { __typename?: 'SimpleResult', success?: boolean | null } | null } | null };

export type UpdateUserZoneMutationVariables = Exact<{
  input: UpdateUserZoneInput;
}>;


export type UpdateUserZoneMutation = { __typename?: 'Mutation', updateUserZone?: { __typename?: 'UpdateUserZonePayload', userZone?: { __typename?: 'UserZone', color: string, id: number, data: any, name: string, kilometerPrice: { __typename?: 'Price', amount?: any | null, currency?: string | null }, rules: { __typename?: 'Timesandrule', exrules?: Array<{ __typename?: 'Rruleeditorxvalue', rule?: string | null, holiday?: { __typename?: 'Holidayvalue', days?: Array<number | null> | null, holidays?: Array<{ __typename?: 'Holiday', country?: string | null, id?: number | null, name?: string | null } | null> | null } | null } | null> | null, rules?: Array<{ __typename?: 'Rruleeditorxvalue', rule?: string | null, holiday?: { __typename?: 'Holidayvalue', days?: Array<number | null> | null, holidays?: Array<{ __typename?: 'Holiday', id?: number | null, country?: string | null, name?: string | null } | null> | null } | null } | null> | null, times?: Array<{ __typename?: 'Timespan', end?: any | null, start?: any | null } | null> | null } } | null } | null };

export type UserZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserZonesQuery = { __typename?: 'Query', userZones?: { __typename?: 'UserZonesConnection', nodes: Array<{ __typename?: 'UserZone', name: string, id: number, color: string, kilometerPrice: { __typename?: 'Price', amount?: any | null, currency?: string | null }, geometry: { __typename?: 'UserZoneGeometriesConnection', nodes: Array<{ __typename?: 'UserZoneGeometry', id: number, value: { __typename?: 'GeometryGeometryCollection', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionM', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionZ', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionZM', geojson?: any | null } | { __typename?: 'GeometryLineString', geojson?: any | null } | { __typename?: 'GeometryLineStringM', geojson?: any | null } | { __typename?: 'GeometryLineStringZ', geojson?: any | null } | { __typename?: 'GeometryLineStringZM', geojson?: any | null } | { __typename?: 'GeometryMultiLineString', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringM', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringZ', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringZM', geojson?: any | null } | { __typename?: 'GeometryMultiPoint', geojson?: any | null } | { __typename?: 'GeometryMultiPointM', geojson?: any | null } | { __typename?: 'GeometryMultiPointZ', geojson?: any | null } | { __typename?: 'GeometryMultiPointZM', geojson?: any | null } | { __typename?: 'GeometryMultiPolygon', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonM', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonZ', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonZM', geojson?: any | null } | { __typename?: 'GeometryPoint', geojson?: any | null } | { __typename?: 'GeometryPointM', geojson?: any | null } | { __typename?: 'GeometryPointZ', geojson?: any | null } | { __typename?: 'GeometryPointZM', geojson?: any | null } | { __typename?: 'GeometryPolygon', geojson?: any | null } | { __typename?: 'GeometryPolygonM', geojson?: any | null } | { __typename?: 'GeometryPolygonZ', geojson?: any | null } | { __typename?: 'GeometryPolygonZM', geojson?: any | null } } | null> }, rules: { __typename?: 'Timesandrule', exrules?: Array<{ __typename?: 'Rruleeditorxvalue', rule?: string | null, holiday?: { __typename?: 'Holidayvalue', days?: Array<number | null> | null, holidays?: Array<{ __typename?: 'Holiday', country?: string | null, id?: number | null, name?: string | null } | null> | null } | null } | null> | null, rules?: Array<{ __typename?: 'Rruleeditorxvalue', rule?: string | null, holiday?: { __typename?: 'Holidayvalue', days?: Array<number | null> | null, holidays?: Array<{ __typename?: 'Holiday', id?: number | null, country?: string | null, name?: string | null } | null> | null } | null } | null> | null, times?: Array<{ __typename?: 'Timespan', end?: any | null, start?: any | null } | null> | null } } | null> } | null };

export type CreateUserZoneGeometryMutationVariables = Exact<{
  input: CreateUserZoneGeometryInput;
}>;


export type CreateUserZoneGeometryMutation = { __typename?: 'Mutation', createUserZoneGeometry?: { __typename?: 'CreateUserZoneGeometryPayload', results?: Array<{ __typename?: 'CreateUserZoneGeometryRecord', id?: number | null, zoneId?: number | null, type?: CrudType | null, newValue?: { __typename?: 'GeometryGeometryCollection', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionM', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionZ', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionZM', geojson?: any | null } | { __typename?: 'GeometryLineString', geojson?: any | null } | { __typename?: 'GeometryLineStringM', geojson?: any | null } | { __typename?: 'GeometryLineStringZ', geojson?: any | null } | { __typename?: 'GeometryLineStringZM', geojson?: any | null } | { __typename?: 'GeometryMultiLineString', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringM', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringZ', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringZM', geojson?: any | null } | { __typename?: 'GeometryMultiPoint', geojson?: any | null } | { __typename?: 'GeometryMultiPointM', geojson?: any | null } | { __typename?: 'GeometryMultiPointZ', geojson?: any | null } | { __typename?: 'GeometryMultiPointZM', geojson?: any | null } | { __typename?: 'GeometryMultiPolygon', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonM', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonZ', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonZM', geojson?: any | null } | { __typename?: 'GeometryPoint', geojson?: any | null } | { __typename?: 'GeometryPointM', geojson?: any | null } | { __typename?: 'GeometryPointZ', geojson?: any | null } | { __typename?: 'GeometryPointZM', geojson?: any | null } | { __typename?: 'GeometryPolygon', geojson?: any | null } | { __typename?: 'GeometryPolygonM', geojson?: any | null } | { __typename?: 'GeometryPolygonZ', geojson?: any | null } | { __typename?: 'GeometryPolygonZM', geojson?: any | null } | null } | null> | null } | null };

export type DeleteUserZoneGeometryMutationVariables = Exact<{
  input: DeleteUserZoneGeometryInput;
}>;


export type DeleteUserZoneGeometryMutation = { __typename?: 'Mutation', deleteUserZoneGeometry?: { __typename?: 'DeleteUserZoneGeometryPayload', simpleResult?: { __typename?: 'SimpleResult', success?: boolean | null } | null } | null };

export type UpdateGeometryZoneMutationVariables = Exact<{
  input: UpdateGeometryZoneInput;
}>;


export type UpdateGeometryZoneMutation = { __typename?: 'Mutation', updateGeometryZone?: { __typename?: 'UpdateGeometryZonePayload', userZoneGeometry?: { __typename?: 'UserZoneGeometry', id: number, value: { __typename?: 'GeometryGeometryCollection', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionM', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionZ', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionZM', geojson?: any | null } | { __typename?: 'GeometryLineString', geojson?: any | null } | { __typename?: 'GeometryLineStringM', geojson?: any | null } | { __typename?: 'GeometryLineStringZ', geojson?: any | null } | { __typename?: 'GeometryLineStringZM', geojson?: any | null } | { __typename?: 'GeometryMultiLineString', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringM', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringZ', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringZM', geojson?: any | null } | { __typename?: 'GeometryMultiPoint', geojson?: any | null } | { __typename?: 'GeometryMultiPointM', geojson?: any | null } | { __typename?: 'GeometryMultiPointZ', geojson?: any | null } | { __typename?: 'GeometryMultiPointZM', geojson?: any | null } | { __typename?: 'GeometryMultiPolygon', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonM', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonZ', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonZM', geojson?: any | null } | { __typename?: 'GeometryPoint', geojson?: any | null } | { __typename?: 'GeometryPointM', geojson?: any | null } | { __typename?: 'GeometryPointZ', geojson?: any | null } | { __typename?: 'GeometryPointZM', geojson?: any | null } | { __typename?: 'GeometryPolygon', geojson?: any | null } | { __typename?: 'GeometryPolygonM', geojson?: any | null } | { __typename?: 'GeometryPolygonZ', geojson?: any | null } | { __typename?: 'GeometryPolygonZM', geojson?: any | null } } | null } | null };

export type UpdateUserZoneGeometryMutationVariables = Exact<{
  input: UpdateUserZoneGeometryInput;
}>;


export type UpdateUserZoneGeometryMutation = { __typename?: 'Mutation', updateUserZoneGeometry?: { __typename?: 'UpdateUserZoneGeometryPayload', results?: Array<{ __typename?: 'UserZoneGeometryResult', id?: number | null, zoneId?: number | null, type?: CrudType | null, newValue?: { __typename?: 'GeometryGeometryCollection', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionM', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionZ', geojson?: any | null } | { __typename?: 'GeometryGeometryCollectionZM', geojson?: any | null } | { __typename?: 'GeometryLineString', geojson?: any | null } | { __typename?: 'GeometryLineStringM', geojson?: any | null } | { __typename?: 'GeometryLineStringZ', geojson?: any | null } | { __typename?: 'GeometryLineStringZM', geojson?: any | null } | { __typename?: 'GeometryMultiLineString', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringM', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringZ', geojson?: any | null } | { __typename?: 'GeometryMultiLineStringZM', geojson?: any | null } | { __typename?: 'GeometryMultiPoint', geojson?: any | null } | { __typename?: 'GeometryMultiPointM', geojson?: any | null } | { __typename?: 'GeometryMultiPointZ', geojson?: any | null } | { __typename?: 'GeometryMultiPointZM', geojson?: any | null } | { __typename?: 'GeometryMultiPolygon', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonM', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonZ', geojson?: any | null } | { __typename?: 'GeometryMultiPolygonZM', geojson?: any | null } | { __typename?: 'GeometryPoint', geojson?: any | null } | { __typename?: 'GeometryPointM', geojson?: any | null } | { __typename?: 'GeometryPointZ', geojson?: any | null } | { __typename?: 'GeometryPointZM', geojson?: any | null } | { __typename?: 'GeometryPolygon', geojson?: any | null } | { __typename?: 'GeometryPolygonM', geojson?: any | null } | { __typename?: 'GeometryPolygonZ', geojson?: any | null } | { __typename?: 'GeometryPolygonZM', geojson?: any | null } | null } | null> | null } | null };


export const AuthDocument = gql`
    mutation Auth($input: AuthInput!) {
  auth(input: $input) {
    result {
      expiresAt
      success
      token
    }
  }
}
    `;
export type AuthMutationFn = Apollo.MutationFunction<AuthMutation, AuthMutationVariables>;
export type AuthMutationResult = Apollo.MutationResult<AuthMutation>;
export type AuthMutationOptions = Apollo.BaseMutationOptions<AuthMutation, AuthMutationVariables>;
export const CreateMagicLinkDocument = gql`
    mutation CreateMagicLink($input: CreateMagicLinkInput!) {
  createMagicLink(input: $input) {
    success
    guid
    errors {
      message
      code
    }
  }
}
    `;
export type CreateMagicLinkMutationFn = Apollo.MutationFunction<CreateMagicLinkMutation, CreateMagicLinkMutationVariables>;
export type CreateMagicLinkMutationResult = Apollo.MutationResult<CreateMagicLinkMutation>;
export type CreateMagicLinkMutationOptions = Apollo.BaseMutationOptions<CreateMagicLinkMutation, CreateMagicLinkMutationVariables>;
export const CreateBookingDocument = gql`
    mutation CreateBooking($input: CreateBookingInput) {
  createBooking(input: $input) {
    success
    userBooking {
      id
    }
  }
}
    `;
export type CreateBookingMutationFn = Apollo.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>;
export type CreateBookingMutationResult = Apollo.MutationResult<CreateBookingMutation>;
export type CreateBookingMutationOptions = Apollo.BaseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>;
export const GetPossibleAppointmentsDocument = gql`
    query GetPossibleAppointments($input: GetPossibleAppointmentsInput!) {
  getPossibleAppointments(input: $input) {
    count
    result {
      cost
      serviceEnd
      serviceStart
      totalDuration
      service {
        cost
        duration
      }
      commute {
        to {
          cost {
            distance
            time
          }
          costCurrency
          distance
          totalCost
          end
          start
        }
        from {
          cost {
            distance
            time
          }
          costCurrency
          distance
          totalCost
          end
          start
        }
        totalCost
        totalDistance
        totalDuration
        bufferTime
      }
    }
  }
}
    `;
export type GetPossibleAppointmentsQueryResult = Apollo.QueryResult<GetPossibleAppointmentsQuery, GetPossibleAppointmentsQueryVariables>;
export const AllCountriesDocument = gql`
    query AllCountries {
  countries(filter: {deletedAt: {isNull: true}, isActive: {equalTo: true}}) {
    nodes {
      id
      iso2
      name
      translations
    }
  }
}
    `;
export type AllCountriesQueryResult = Apollo.QueryResult<AllCountriesQuery, AllCountriesQueryVariables>;
export const GeocodeDocument = gql`
    mutation Geocode($input: GeocodeInput!) {
  geocode(input: $input) {
    latitude
    longitude
    state
    streetName
    streetNumber
    zipcode
    city
    country
  }
}
    `;
export type GeocodeMutationFn = Apollo.MutationFunction<GeocodeMutation, GeocodeMutationVariables>;
export type GeocodeMutationResult = Apollo.MutationResult<GeocodeMutation>;
export type GeocodeMutationOptions = Apollo.BaseMutationOptions<GeocodeMutation, GeocodeMutationVariables>;
export const ReverseGeocodeDocument = gql`
    mutation ReverseGeocode($input: ReverseGeocodeInput!) {
  reverseGeocode(input: $input) {
    city
    country
    countryCode
    latitude
    longitude
    provider
    state
    streetName
    streetNumber
    zipcode
    stateCode
    formattedAddress
    district
    county
    building
    extra {
      confidence
      googlePlaceId
    }
    administrativeLevels {
      level1long
      level1short
      level2long
      level2short
    }
  }
}
    `;
export type ReverseGeocodeMutationFn = Apollo.MutationFunction<ReverseGeocodeMutation, ReverseGeocodeMutationVariables>;
export type ReverseGeocodeMutationResult = Apollo.MutationResult<ReverseGeocodeMutation>;
export type ReverseGeocodeMutationOptions = Apollo.BaseMutationOptions<ReverseGeocodeMutation, ReverseGeocodeMutationVariables>;
export const MeRequestDocument = gql`
    query MeRequest {
  me {
    id
    role
    emailAddresses(filter: {deletedAt: {isNull: true}}) {
      nodes {
        value
      }
    }
    userDevices(orderBy: MODIFIED_AT_DESC, filter: {deletedAt: {isNull: true}}) {
      nodes {
        id
        info
        subscriptions(filter: {deletedAt: {isNull: true}}) {
          nodes {
            id
            topic
            userDeviceId
          }
        }
        deletedAt
        modifiedAt
      }
    }
    userRoutingHomes(filter: {deletedAt: {isNull: true}}) {
      nodes {
        point {
          x
          y
        }
        data
      }
    }
  }
  serverTime {
    value
  }
}
    `;
export type MeRequestQueryResult = Apollo.QueryResult<MeRequestQuery, MeRequestQueryVariables>;
export const NotifyUserDocument = gql`
    mutation NotifyUser($input: NotifyUserInput!) {
  notifyUser(input: $input) {
    success
  }
}
    `;
export type NotifyUserMutationFn = Apollo.MutationFunction<NotifyUserMutation, NotifyUserMutationVariables>;
export type NotifyUserMutationResult = Apollo.MutationResult<NotifyUserMutation>;
export type NotifyUserMutationOptions = Apollo.BaseMutationOptions<NotifyUserMutation, NotifyUserMutationVariables>;
export const SubscribToNewsletterDocument = gql`
    mutation SubscribToNewsletter($input: NewsletterSubscribeRequest!) {
  subscribeToNewsletter(input: $input) {
    success
    errors
  }
}
    `;
export type SubscribToNewsletterMutationFn = Apollo.MutationFunction<SubscribToNewsletterMutation, SubscribToNewsletterMutationVariables>;
export type SubscribToNewsletterMutationResult = Apollo.MutationResult<SubscribToNewsletterMutation>;
export type SubscribToNewsletterMutationOptions = Apollo.BaseMutationOptions<SubscribToNewsletterMutation, SubscribToNewsletterMutationVariables>;
export const SubscribeDocument = gql`
    mutation Subscribe($input: SubscribeInput!) {
  subscribe(input: $input) {
    simpleResult {
      success
    }
  }
}
    `;
export type SubscribeMutationFn = Apollo.MutationFunction<SubscribeMutation, SubscribeMutationVariables>;
export type SubscribeMutationResult = Apollo.MutationResult<SubscribeMutation>;
export type SubscribeMutationOptions = Apollo.BaseMutationOptions<SubscribeMutation, SubscribeMutationVariables>;
export const UnsubscribeDocument = gql`
    mutation Unsubscribe($input: UnsubscribeInput!) {
  unsubscribe(input: $input) {
    simpleResult {
      success
    }
  }
}
    `;
export type UnsubscribeMutationFn = Apollo.MutationFunction<UnsubscribeMutation, UnsubscribeMutationVariables>;
export type UnsubscribeMutationResult = Apollo.MutationResult<UnsubscribeMutation>;
export type UnsubscribeMutationOptions = Apollo.BaseMutationOptions<UnsubscribeMutation, UnsubscribeMutationVariables>;
export const AllTopicsDocument = gql`
    query AllTopics {
  allTopics {
    nodes {
      id
    }
  }
}
    `;
export type AllTopicsQueryResult = Apollo.QueryResult<AllTopicsQuery, AllTopicsQueryVariables>;
export const AllUserCalendarEntriesDocument = gql`
    query allUserCalendarEntries($filter: UserCalendarEntryFilter) {
  userCalendarEntries(filter: $filter) {
    nodes {
      id
      type
      route {
        bbox
        geometry
        segments {
          distance
          duration
          steps {
            distance
            duration
            instruction
            name
            type
            wayPoints
          }
        }
        summary {
          distance
          duration
        }
        wayPoints
      }
      userBooking {
        userZone {
          id
          color
          name
        }
        endingAt
        startingAt
        point {
          x
          y
          geojson
          srid
        }
        id
        guid
        createdAt
        userId
      }
      startingAt
      endingAt
      deletedAt
    }
  }
}
    `;
export type AllUserCalendarEntriesQueryResult = Apollo.QueryResult<AllUserCalendarEntriesQuery, AllUserCalendarEntriesQueryVariables>;
export const DeleteUserDeviceDocument = gql`
    mutation DeleteUserDevice($input: DeleteUserDeviceInput!) {
  deleteUserDevice(input: $input) {
    simpleResult {
      success
    }
  }
}
    `;
export type DeleteUserDeviceMutationFn = Apollo.MutationFunction<DeleteUserDeviceMutation, DeleteUserDeviceMutationVariables>;
export type DeleteUserDeviceMutationResult = Apollo.MutationResult<DeleteUserDeviceMutation>;
export type DeleteUserDeviceMutationOptions = Apollo.BaseMutationOptions<DeleteUserDeviceMutation, DeleteUserDeviceMutationVariables>;
export const UpsertUserDeviceDocument = gql`
    mutation UpsertUserDevice($input: UpsertUserDeviceInput!, $id: String!) {
  upsertUserDevice(input: $input, where: {id: $id}) {
    userDevice {
      id
      info
      subscription
    }
  }
}
    `;
export type UpsertUserDeviceMutationFn = Apollo.MutationFunction<UpsertUserDeviceMutation, UpsertUserDeviceMutationVariables>;
export type UpsertUserDeviceMutationResult = Apollo.MutationResult<UpsertUserDeviceMutation>;
export type UpsertUserDeviceMutationOptions = Apollo.BaseMutationOptions<UpsertUserDeviceMutation, UpsertUserDeviceMutationVariables>;
export const UserDevicesDocument = gql`
    query UserDevices {
  userDevices(orderBy: MODIFIED_AT_DESC, filter: {deletedAt: {isNull: true}}) {
    nodes {
      id
      info
      subscription
      createdAt
      modifiedAt
    }
  }
}
    `;
export type UserDevicesQueryResult = Apollo.QueryResult<UserDevicesQuery, UserDevicesQueryVariables>;
export const CreateUserRoutingHomeDocument = gql`
    mutation CreateUserRoutingHome($input: CreateUserRoutingHomeInput!) {
  createUserRoutingHome(input: $input) {
    userRoutingHomeEdge {
      node {
        id
        point {
          geojson
          srid
          x
          y
        }
        data
      }
    }
  }
}
    `;
export type CreateUserRoutingHomeMutationFn = Apollo.MutationFunction<CreateUserRoutingHomeMutation, CreateUserRoutingHomeMutationVariables>;
export type CreateUserRoutingHomeMutationResult = Apollo.MutationResult<CreateUserRoutingHomeMutation>;
export type CreateUserRoutingHomeMutationOptions = Apollo.BaseMutationOptions<CreateUserRoutingHomeMutation, CreateUserRoutingHomeMutationVariables>;
export const CreateUserServiceDocument = gql`
    mutation CreateUserService($input: CreateUserServiceInput!) {
  createUserService(input: $input) {
    userService {
      id
      guid
      data
      createdAt
      parentId
      type
      name
      index
      duration {
        hours
        minutes
      }
      price {
        amount
        currency
      }
      description
    }
  }
}
    `;
export type CreateUserServiceMutationFn = Apollo.MutationFunction<CreateUserServiceMutation, CreateUserServiceMutationVariables>;
export type CreateUserServiceMutationResult = Apollo.MutationResult<CreateUserServiceMutation>;
export type CreateUserServiceMutationOptions = Apollo.BaseMutationOptions<CreateUserServiceMutation, CreateUserServiceMutationVariables>;
export const DeleteUserServiceDocument = gql`
    mutation DeleteUserService($id: Int) {
  deleteUserService(input: {id: $id}) {
    simpleResult {
      success
    }
  }
}
    `;
export type DeleteUserServiceMutationFn = Apollo.MutationFunction<DeleteUserServiceMutation, DeleteUserServiceMutationVariables>;
export type DeleteUserServiceMutationResult = Apollo.MutationResult<DeleteUserServiceMutation>;
export type DeleteUserServiceMutationOptions = Apollo.BaseMutationOptions<DeleteUserServiceMutation, DeleteUserServiceMutationVariables>;
export const UpdateUserServiceDocument = gql`
    mutation UpdateUserService($id: Int!, $patch: UserServicePatch!) {
  updateUserService(input: {patch: $patch, id: $id}) {
    userService {
      type
      parentId
      name
      index
      id
      guid
      data
      createdAt
      duration {
        hours
        minutes
      }
      price {
        amount
        currency
      }
      description
    }
  }
}
    `;
export type UpdateUserServiceMutationFn = Apollo.MutationFunction<UpdateUserServiceMutation, UpdateUserServiceMutationVariables>;
export type UpdateUserServiceMutationResult = Apollo.MutationResult<UpdateUserServiceMutation>;
export type UpdateUserServiceMutationOptions = Apollo.BaseMutationOptions<UpdateUserServiceMutation, UpdateUserServiceMutationVariables>;
export const UpdateUserServiceIndexDocument = gql`
    mutation UpdateUserServiceIndex($input: UpdateUserServiceIndexInput!) {
  updateUserServiceIndex(input: $input) {
    simpleResult {
      success
    }
  }
}
    `;
export type UpdateUserServiceIndexMutationFn = Apollo.MutationFunction<UpdateUserServiceIndexMutation, UpdateUserServiceIndexMutationVariables>;
export type UpdateUserServiceIndexMutationResult = Apollo.MutationResult<UpdateUserServiceIndexMutation>;
export type UpdateUserServiceIndexMutationOptions = Apollo.BaseMutationOptions<UpdateUserServiceIndexMutation, UpdateUserServiceIndexMutationVariables>;
export const UserServiceDocument = gql`
    query UserService {
  userServiceViews(orderBy: INDEX_ASC) {
    nodes {
      type
      parentId
      name
      index
      id
      guid
      data
      createdAt
      duration {
        hours
        minutes
      }
      price {
        amount
        currency
      }
      description
    }
  }
}
    `;
export type UserServiceQueryResult = Apollo.QueryResult<UserServiceQuery, UserServiceQueryVariables>;
export const CreateUserZoneDocument = gql`
    mutation CreateUserZone($input: CreateUserZoneInput!) {
  createUserZone(input: $input) {
    userZone {
      id
      name
      color
      kilometerPrice {
        amount
        currency
      }
      rules {
        exrules {
          holiday {
            days
            holidays {
              country
              id
              name
            }
          }
          rule
        }
        rules {
          rule
          holiday {
            days
            holidays {
              id
              country
              name
            }
          }
        }
        times {
          end
          start
        }
      }
    }
  }
}
    `;
export type CreateUserZoneMutationFn = Apollo.MutationFunction<CreateUserZoneMutation, CreateUserZoneMutationVariables>;
export type CreateUserZoneMutationResult = Apollo.MutationResult<CreateUserZoneMutation>;
export type CreateUserZoneMutationOptions = Apollo.BaseMutationOptions<CreateUserZoneMutation, CreateUserZoneMutationVariables>;
export const DeleteUserZoneDocument = gql`
    mutation DeleteUserZone($id: Int!) {
  deleteUserZone(input: {id: $id}) {
    simpleResult {
      success
    }
  }
}
    `;
export type DeleteUserZoneMutationFn = Apollo.MutationFunction<DeleteUserZoneMutation, DeleteUserZoneMutationVariables>;
export type DeleteUserZoneMutationResult = Apollo.MutationResult<DeleteUserZoneMutation>;
export type DeleteUserZoneMutationOptions = Apollo.BaseMutationOptions<DeleteUserZoneMutation, DeleteUserZoneMutationVariables>;
export const UpdateUserZoneDocument = gql`
    mutation UpdateUserZone($input: UpdateUserZoneInput!) {
  updateUserZone(input: $input) {
    userZone {
      color
      id
      data
      name
      kilometerPrice {
        amount
        currency
      }
      rules {
        exrules {
          holiday {
            days
            holidays {
              country
              id
              name
            }
          }
          rule
        }
        rules {
          rule
          holiday {
            days
            holidays {
              id
              country
              name
            }
          }
        }
        times {
          end
          start
        }
      }
    }
  }
}
    `;
export type UpdateUserZoneMutationFn = Apollo.MutationFunction<UpdateUserZoneMutation, UpdateUserZoneMutationVariables>;
export type UpdateUserZoneMutationResult = Apollo.MutationResult<UpdateUserZoneMutation>;
export type UpdateUserZoneMutationOptions = Apollo.BaseMutationOptions<UpdateUserZoneMutation, UpdateUserZoneMutationVariables>;
export const UserZonesDocument = gql`
    query UserZones {
  userZones(filter: {deletedAt: {isNull: true}}) {
    nodes {
      name
      id
      color
      kilometerPrice {
        amount
        currency
      }
      geometry(filter: {deletedAt: {isNull: true}}) {
        nodes {
          value {
            geojson
          }
          id
        }
      }
      rules {
        exrules {
          holiday {
            days
            holidays {
              country
              id
              name
            }
          }
          rule
        }
        rules {
          rule
          holiday {
            days
            holidays {
              id
              country
              name
            }
          }
        }
        times {
          end
          start
        }
      }
    }
  }
}
    `;
export type UserZonesQueryResult = Apollo.QueryResult<UserZonesQuery, UserZonesQueryVariables>;
export const CreateUserZoneGeometryDocument = gql`
    mutation CreateUserZoneGeometry($input: CreateUserZoneGeometryInput!) {
  createUserZoneGeometry(input: $input) {
    results {
      id
      zoneId
      type
      newValue {
        geojson
      }
    }
  }
}
    `;
export type CreateUserZoneGeometryMutationFn = Apollo.MutationFunction<CreateUserZoneGeometryMutation, CreateUserZoneGeometryMutationVariables>;
export type CreateUserZoneGeometryMutationResult = Apollo.MutationResult<CreateUserZoneGeometryMutation>;
export type CreateUserZoneGeometryMutationOptions = Apollo.BaseMutationOptions<CreateUserZoneGeometryMutation, CreateUserZoneGeometryMutationVariables>;
export const DeleteUserZoneGeometryDocument = gql`
    mutation DeleteUserZoneGeometry($input: DeleteUserZoneGeometryInput!) {
  deleteUserZoneGeometry(input: $input) {
    simpleResult {
      success
    }
  }
}
    `;
export type DeleteUserZoneGeometryMutationFn = Apollo.MutationFunction<DeleteUserZoneGeometryMutation, DeleteUserZoneGeometryMutationVariables>;
export type DeleteUserZoneGeometryMutationResult = Apollo.MutationResult<DeleteUserZoneGeometryMutation>;
export type DeleteUserZoneGeometryMutationOptions = Apollo.BaseMutationOptions<DeleteUserZoneGeometryMutation, DeleteUserZoneGeometryMutationVariables>;
export const UpdateGeometryZoneDocument = gql`
    mutation UpdateGeometryZone($input: UpdateGeometryZoneInput!) {
  updateGeometryZone(input: $input) {
    userZoneGeometry {
      id
      value {
        geojson
      }
    }
  }
}
    `;
export type UpdateGeometryZoneMutationFn = Apollo.MutationFunction<UpdateGeometryZoneMutation, UpdateGeometryZoneMutationVariables>;
export type UpdateGeometryZoneMutationResult = Apollo.MutationResult<UpdateGeometryZoneMutation>;
export type UpdateGeometryZoneMutationOptions = Apollo.BaseMutationOptions<UpdateGeometryZoneMutation, UpdateGeometryZoneMutationVariables>;
export const UpdateUserZoneGeometryDocument = gql`
    mutation UpdateUserZoneGeometry($input: UpdateUserZoneGeometryInput!) {
  updateUserZoneGeometry(input: $input) {
    results {
      id
      zoneId
      type
      newValue {
        geojson
      }
    }
  }
}
    `;
export type UpdateUserZoneGeometryMutationFn = Apollo.MutationFunction<UpdateUserZoneGeometryMutation, UpdateUserZoneGeometryMutationVariables>;
export type UpdateUserZoneGeometryMutationResult = Apollo.MutationResult<UpdateUserZoneGeometryMutation>;
export type UpdateUserZoneGeometryMutationOptions = Apollo.BaseMutationOptions<UpdateUserZoneGeometryMutation, UpdateUserZoneGeometryMutationVariables>;